import React, { useState, useEffect, useCallback, useRef } from "react";
import Logo from "../images/logo.svg";
import Sidebar from "../component/Sidebar";
import {
  Avatar,
  SelectPicker,
  DatePicker,
  Drawer,
  Placeholder,
  Whisper,
  Button,
  Popover,
  Stack,
  Message,
  useToaster,
  Tooltip,
  Input,
  Loader,
  Modal,
  Uploader,
  Progress,
} from "rsuite";
import "rsuite/SelectPicker/styles/index.css";
import { json, Link } from "react-router-dom";
import "aos/dist/aos.css";
import AOS from "aos";
import debounce from "lodash.debounce";
import IconDelete from "../images/deleteBG.svg";
import IconInfo from "../images/IconErrorInfo.svg";
import IconError from "../images/IconError.svg";
import IconCheckError from "../images/IconCheckError.svg";
import iconUpload from "../images/iconUpload.svg";

import icon_Asc from "../images/Asc.svg";
import icon_Desc from "../images/Desc.svg";

import icon1_Asc from "../images/Asc.svg";
import icon1_Desc from "../images/Desc.svg";

import icon2_Asc from "../images/Asc.svg";
import icon2_Desc from "../images/Desc.svg";

import icon3_Asc from "../images/Asc.svg";
import icon3_Desc from "../images/Desc.svg";

import iconArrowDrop from "../images/iconArrowDrop.svg";
import Icon_info from "../images/iconInfo.svg";
import mockData from "../sample/mockData.json";

import iconUS from "../images/flag/usa.svg";
import iconIN from "../images/flag/india.svg";
import iconBangla from "../images/flag/bangladesh.svg";
import iconUAE from "../images/flag/uae.png";
import iconsaudi from "../images/flag/saudi.svg";
import iconPakistan from "../images/flag/pakistan.svg";
import iconUK from "../images/flag/uk.svg";
import iconQatar from "../images/flag/qatar.svg";
import iconkuwait from "../images/kuwait.svg";
import iconbahrain from "../images/bahrain.svg";
import iconUSA from "../images/flag/usa.svg";

import iconWhatsapp from "../images/contact/Whatsapp.svg";
import iconMail from "../images/contact/mail.svg";
import iconPhone from "../images/contact/phone.svg";
import iconSMS from "../images/contact/MSG.svg";
import iconTelegram from "../images/contact/telegram.svg";
import iconZoom from "../images/contact/zoom.svg";

import iconGoogle from "../images/contact/google.svg";
import iconTwitter from "../images/contact/twitter.svg";
import iconNewsletter from "../images/contact/newsletter.svg";
import IconEye from "../images/iconEye.svg";

import { parsePhoneNumberFromString } from "libphonenumber-js";
import IconRefresh from "../images/iconRefresh.svg";
import { encryptData, decryptData } from "./cryptoUtil";
import moment from "moment-timezone";
import { ChakraProvider, useToast, Wrap } from "@chakra-ui/react";
import { CircleFlag } from "react-circle-flags";
import LoaderFull from "../component/Loader";
import IconNoComment from "../images/noComment.svg";
import iconNotes from "../images/iconNotes.svg";
import Football from "../images/football-kicking.gif";
import iconJPG from "../images/iconJPG.svg";
import iconPNG from "../images/iconPNG.svg";
import iconPDF from "../images/IconCertificate.svg";
import iconCancel from "../images/iconCancel.svg";
import iconUploadbtn from "../images/icon-btn-upload.svg";
import { auto } from "@popperjs/core";
import IconCertificate from "../images/IconCertificate.svg";

import iconBonus from "../images/iconBonus6.svg";
import iconBonus1 from "../images/iconBonus1.svg";

function Investors() {
  const [tabName, setTabName] = useState("Investors");

  useEffect(() => {
    document.title = tabName;
  }, [tabName]);

  const timeZone = "Asia/Kolkata";

  const orderData = ["ASC", "DESC"].map((item) => ({
    label: item,
    value: item,
  }));

  const CBAStatus = ["Pass", "Fail"].map((item) => ({
    label: item,
    value: item,
  }));

  const statusData = [
    { label: "Publish", value: true },
    { label: "UnPublish", value: false },
    { label: "Both", value: "" },
  ];

  const subscriptionData = [
    { label: "Freemium", value: "FREEMIUM" },
    { label: "Premium", value: "PREMIUM" },
    { label: "Premium Plus", value: "PREMIUM_PLUS" },
    { label: "Starter", value: "STARTER" },
    { label: "Others", value: 'OTHERS' },
  ];

  useEffect(() => {
    AOS.init();
  }, []);

  const toast = useToast();
  const toastIdRef = React.useRef();

  const abortControllerRef = useRef(null);
  const [isLoading, setLoading] = useState(false); // State to manage loading state
  const [globalLoading, setGlobalLoading] = useState(true); // State to manage loading state
  const abortControllerRefGlobal = useRef(null);
  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const apiUrl = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_API_KEY;

  const roleName = localStorage.getItem("novaRolename");
  const merlinJuniorAnalyst = process.env.REACT_APP_MERLIN_JUNIOR_ANALYST;
  const [pageRange, setPageRange] = useState("20");
  const [reportdata, setReportData] = useState([]);
  const [reportCount, setReportCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [startPage, setStartPage] = useState(1);
  const [countryCode, setCountryCode] = useState("");
  const [complianceId, setComplianceId] = useState("");
  const [progressId, setProgressId] = useState("");
  const [scoreId, setScoreId] = useState("");

  const [orderBy, setOrderBy] = useState("id"); // default orderBy
  const [order, setOrder] = useState("DESC"); // default order

  const [investmentamount, setInvestmentamount] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [investmentFrom, setInvestmentFrom] = useState(0);
  const [investmentTo, setInvestmentTo] = useState(0);

  const [minValue, setMinValue] = useState("");
  const [maxValue, setMaxValue] = useState("");

  const [CMPTminValue, setCMPTMinValue] = useState("");
  const [CMPTmaxValue, setCMPTMaxValue] = useState("");

  const [NCMPTminValue, setNCMPTMinValue] = useState("");
  const [NCMPTmaxValue, setNCMPTMaxValue] = useState("");

  const [DBFTminValue, setDBFTMinValue] = useState("");
  const [DBFTmaxValue, setDBFTMaxValue] = useState("");

  const [IntrestminValue, setIntrestMinValue] = useState("");
  const [IntrestmaxValue, setIntrestMaxValue] = useState("");

  const [DEBTminValue, setDEBTMinValue] = useState("");
  const [DEBTmaxValue, setDEBTMaxValue] = useState("");

  const [countryData, setCountryData] = useState([]);
  const [complianceData, setComplianceData] = useState([]);
  const [subscriptionId, setSubscriptionId] = useState();
  const [selectedQuarter, setSelectedQuarter] = useState("");

  const userid = sessionStorage.getItem("userId");
  const [userData, setUserData] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  const [errorMessage, setErrorMessage] = useState("");
  const [messageType, setMessageType] = useState(null); // success, error, info
  const [assetClassData, setAssetClassData] = useState([]);
  const [searchAsset, setSearchAsset] = useState("Equity");

  const [isAscending, setIsAscending] = useState(false);
  const [isAscending1, setIsAscending1] = useState(true);
  const [isAscending2, setIsAscending2] = useState(true);

  const [filterDate, setFilterDate] = useState(null);
  const [assignUserid, setAssignUserid] = useState("");
  const [assignUserComment, setAssignUserComment] = useState("");
  const [selectedInvestorId, setSelectedInvestorId] = useState();
  const [scoreFrom, setScoreFrom] = useState(null);
const [scoreTo, setScoreTo] = useState(null);


  const [UTMSourceData, setUTMSourceData] = useState([]);
  const [UTMSourceId, setUTMSourceId] = useState("");


  const [AmountBonus, setAmountBonus] = useState("");
  const [TimeBonus, setTimeBonus] = useState("");
  const [EventBonus, setEventBonus] = useState("");
  const [ExistingBonus, setExistingBonus] = useState("");
  const [PremiumBonus, setPremiumBonus] = useState("");
  const [TotalBonus, setTotalBonus] = useState("");

  

  useEffect(() => {
    const fetchCountryList = async () => {
      const url = `${apiEndPoint}/baraka_users`;
      const payload = encryptData({
        data: {
          user_id: userid, // Replace with the actual user_id if dynamic
        },
      });

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: payload,
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        //const data = responseData.data; // Flatten the response
        const data = decryptData(responseData);
        console.log("A" + JSON.stringify(data));

        const formattedUserData = data.data.map((user) => ({
          label: user.fullname,
          value: user.id,
          profile_img: user.profile_img,
        }));

        setUserData(formattedUserData);
      } catch (error) {
        setErrorMessage(error.message);
        setMessageType("error");
        return false;
      }
    };

    fetchCountryList();
  }, []);

  const handleIconClick = (columnName) => {
    // Toggle between ascending and descending icons

    setOrderBy(columnName);

    switch (columnName) {
      case "created_at":
        setIsAscending(!isAscending);
        setOrder(isAscending ? "DESC" : "ASC");
        break;
      case "investment_amount":
        setIsAscending2(!isAscending2);
        setOrder(isAscending2 ? "DESC" : "ASC");
        break;
      default:
        setIsAscending(!isAscending);
        setOrder(isAscending ? "DESC" : "ASC");
        break;
    }
  };

  const handleSubscription = (value) => {
    setSubscriptionId(value);
  };

  useEffect(() => {
    const fetchCountryList = async () => {
      const url = `${apiEndPoint}/country_master`;
      const payload = encryptData({
        data: {
          user_id: userid, // Replace with the actual user_id if dynamic
        },
      });

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: payload,
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        //const data = responseData.data; // Flatten the response
        const data = decryptData(responseData);
        const formattedCountryData = data.data.map((country) => ({
          label: country.country_name,
          value: country.country_code,
        }));

        setCountryData(formattedCountryData);
      } catch (error) {
        setErrorMessage(error.message);
        setMessageType("error");
        return false;
      }
    };

    fetchCountryList();
  }, []);

  useEffect(() => {
    const fetchUTMSourceList = async () => {
      const url = `${apiEndPoint}/utm_source`;
      const payload = encryptData({
        data: {
          user_id: userid, // Replace with the actual user_id if dynamic
        },
      });

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: payload,
        });

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const responseData = await response.json();
        //const data = responseData.data; // Flatten the response
        const data = decryptData(responseData);
        const formattedUTMSourceData = data.data.map((utmSource) => ({
          label: utmSource.utm_source,
          value: utmSource.utm_source,
        }));

        setUTMSourceData(formattedUTMSourceData);
      } catch (error) {
        setErrorMessage(error.message);
        setMessageType("error");
        return false;
      }
    };

    fetchUTMSourceList();
  }, []);

  const defaultColumns = [
    "Action",
    "Investor ID",
    "Full Name",
    "Joint Holder Name",
    "Email Address",
    "Phone Number",
    "Country",
    "Local Time",
    "Likehood Score",
    "Investment Invite Date",
    "Time to First Contact",
    "Total Invested Amount",
    "Assigned User",
    "IR Notes",
    "Source",
    "UTM Source",
    "UTM Medium",
    "UTM Campaign",
    "Referral code",
    "Platform User Type",
    "Platform Usage Status",
    "App User Since",
    "Web User Since",
    "Platform Registration Date",
    "Last Active Date",
    "Total Days Active",
    "Subscription Tier",
    "Time Since Subscription",
    "Days in Current Subscription",
    "Days Between Signup and Invite",
    "Engagement Score",
    "Investment Account Numbers",
    "Regulation Types",
    "Accredited",
    "Dealmaker Certificate",
    "Signed Date",
    "Accepted Date",
    "Number of Investments",
    "Investment Currency",
    "Initial Shares",
    "Weighted Average Shares",
    "Estimated Portfolio Value",
    "Valuation Basis",
    "Time-Based Bonus Shares",
    "Amount-Based Bonus Shares",
    "Repeat Investor Bonus",
    "Premium Subscriber Bonus",
    "Event Based Bonus",
    "Total Bonus Shares",
    "Notes",
    "Mailing Address",
    "certificate",
    "Configure Bonus",
  ];
let callCount = 0;

  const fetchGlobalReport = async () => {
  callCount++;
  console.log(`myFunction called ${callCount} times`);
    setGlobalLoading(true);

    // Cancel the previous request if any
    if (abortControllerRefGlobal.current) {
      abortControllerRefGlobal.current.abort();
    }

    const controller = new AbortController();
    abortControllerRefGlobal.current = controller;

    console.log('score RE : '+ scoreFrom);
console.log('score RE : '+ scoreTo);

    // -------- STEP 1: Fetch Column Order --------
    let finalColumnOrder = [];

    try {
      const columnOrderResponse = await fetch(
        `${apiEndPoint}/user_column_order`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: {
              user_id: userid,
              module: "investers",
            },
          }),
          signal: controller.signal,
        }
      );

      const columnOrderResult = await columnOrderResponse.json();
      const parsedOrder = columnOrderResult.data?.[0]?.column_order;

      if (Array.isArray(parsedOrder) && parsedOrder.length > 0) {
        const activeColumns = parsedOrder
          .filter((col) => col.is_active)
          .map((col) => ({
            name: col.name || "",
            isDraggable: col.isDraggable ?? col.is_draggable ?? true,
          }));

        if (activeColumns.length > 0) {
          finalColumnOrder = activeColumns;
        } else {
          finalColumnOrder = defaultColumns.map((name) => ({
            name,
            isDraggable: true,
          }));
        }
      } else {
        finalColumnOrder = defaultColumns.map((name) => ({
          name,
          isDraggable: true,
        }));
      }
    } catch (error) {
      console.error("Column order fetch failed:", error);
      finalColumnOrder = defaultColumns.map((name) => ({
        name,
        isDraggable: true,
      }));
    }
    console.log("Final Column Order:", finalColumnOrder);
    setColumnOrder(finalColumnOrder);

    // -------- STEP 2: Fetch Investers Data --------

    try {
      const zonedDate = moment(filterDate).isValid()
        ? moment(filterDate).tz(timeZone).format()
        : "";

      const apiUrl = `${apiEndPoint}/investors`;
      const requestData = encryptData({
        data: {
          user_id: userid,
          limit: pageRange,
          page: currentPage.toString(),
          q: searchInput || "",
          order: order,
          country: countryCode || "",
          orderBy: orderBy,
          status: progressId, //progress status
          filter_date: zonedDate || "", //Invited date
          investment_from: investmentFrom,
          investment_to: investmentTo,
          app_role: subscriptionId,
          score_from:scoreFrom,
          score_to:scoreTo,
          utm_source:UTMSourceId
        },
      });

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: requestData,
        signal: controller.signal,
      });

      const jsonData = await response.json();
      const decrypted = decryptData(jsonData);

      if (decrypted.status == "success") {
        setGlobalLoading(false);
        setReportCount(decrypted.count);
        setReportData(decrypted.data);
      } else {
        setGlobalLoading(false);
        setReportCount(decrypted.count);
        setReportData(decrypted.data);
        // toastIdRef.current = toast({ description: decrypted.message, status: 'error', duration: 5000, isClosable: true, position: 'bottom', });
        return false;
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("GLobal Request cancelled");
      } else {
        setGlobalLoading(false);
        setErrorMessage(error.message);
        setMessageType("error");
      }
      return false;
    }
  };

  const debouncedFetchGlobalReport = useCallback(
    debounce(() => {
      fetchGlobalReport();
    }, 1000),
    [searchInput] // Only debounce on search input changes
  );

  useEffect(() => {
    debouncedFetchGlobalReport();
    return () => {
      debouncedFetchGlobalReport.cancel();
    };
  }, [searchInput]);

  useEffect(() => {
    fetchGlobalReport();
  }, [
    currentPage,
    countryCode,
    pageRange,
    filterDate,
    progressId,
    order,
    orderBy,
    investmentFrom,
    subscriptionId,
    refreshKey,
    scoreId,
    UTMSourceId
  ]); // Regular effect for other dependencies

  const handleSearch = (event) => {
    console.log(event.target.value);

    setSearchInput(event.target.value);
    setCurrentPage(1); // Reset to the first page for new search
  };

  const [customPaginationValue, setCustomPaginationValue] = useState("");

  // Debounced function to update the page number
  const debouncedSetPage = useCallback(
    debounce((page) => {
      setCurrentPage(page);
    }, 1000), // Delay of 500ms (half a second)
    []
  );

  const handlePaginationChange = (e) => {
    const value = (e.target.value == 0 ? 1 : e.target.value).toString();
    setCustomPaginationValue(value); // Update input value immediately for fast typing
    debouncedSetPage(Number(value)); // Trigger the debounced function
  };

  const handlePagelimit = (value) => {
    setCurrentPage(1);
    setCustomPaginationValue(1);
    setPageRange(value);
  };

  const handleUserChange = (selectedOption) => {
    setAssignUserid(selectedOption); // Update selectedPeriod state with the selected option
  };

  const renderPagination = () => {
    // Calculate total number of pages
    const totalPages = Math.ceil(reportCount / pageRange);

    // Show a default of 3 pages if the total pages are more than 3
    const pageNumbers = [];
    const visiblePageCount = 4; // Number of pages to show by default

    let startPage = currentPage - 1;
    let endPage = currentPage + 2;

    // Adjust pagination if total pages are less than the default
    if (totalPages <= visiblePageCount) {
      startPage = 1;
      endPage = totalPages;
    } else {
      // Ensure the pagination does not go out of bounds
      startPage = Math.max(1, startPage);
      endPage = Math.min(totalPages, endPage);
    }

    // Create page numbers to display based on current page
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return (
      <nav
        aria-label="..."
        id="pagination_row"
        style={{
          alignItems: "center",
          justifyContent: "space-between",
          background: "#FFF",
          paddingTop: 0,
          paddingBottom: 0,
          zIndex: 3,
          marginBottom: 10,
        }}
      >
        <div className="totalRecords">
          Total Records : {Number(reportCount).toLocaleString()}
        </div>
        <ul className="pagination" style={{ border: 0, background: "none" }}>
          <li class="page-item" style={{ marginLeft: 10 }}>
            <SelectPicker
              onChange={handlePagelimit}
              cleanable={false}
              value={pageRange}
              placement="top"
              placeholder="Pages"
              data={PagingData}
              searchable={false}
              style={{
                width: 85,
                height: 35,
                display: "flex",
                alignItems: "center",
                borderRadius: 5,
                border: "1px solid #A1B9ED",
              }}
            />
          </li>

          {/* Previous Page (Double Arrow) */}
          <li
            className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
            style={{ marginLeft: 10 }}
          >
            <a href="#" className="page-link" onClick={() => setCurrentPage(1)}>
              <i className="fa fa-angle-double-left"></i>
            </a>
          </li>

          {/* Previous Page (Single Arrow) */}
          <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
            <a
              href="#"
              className="page-link"
              onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
            >
              <i className="fa fa-angle-left"></i>
            </a>
          </li>

          {/* Page numbers */}
          {pageNumbers.map((page) => (
            <li
              key={page}
              className={`page-item ${currentPage === page ? "active" : ""}`}
            >
              <a
                className="page-link"
                href="#"
                onClick={() => setCurrentPage(page)} // Set the clicked page as the current page
              >
                {page}
              </a>
            </li>
          ))}

          {/* Next Page (Single Arrow) */}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
          >
            <a
              href="#"
              className="page-link"
              onClick={() =>
                setCurrentPage(Math.min(totalPages, currentPage + 1))
              }
            >
              <i className="fa fa-angle-right"></i>
            </a>
          </li>

          {/* Next Page (Double Arrow) */}
          <li
            className={`page-item ${
              currentPage === totalPages ? "disabled" : ""
            }`}
            style={{ marginRight: 10 }}
          >
            <a
              href="#"
              className="page-link"
              onClick={() => setCurrentPage(totalPages)}
            >
              <i className="fa fa-angle-double-right"></i>
            </a>
          </li>

          {/* Go to Page */}
          <li
            className="page-item"
            style={{
              marginLeft: 10,
              display: "flex",
              alignItems: "center",
              gap: 5,
            }}
          >
            <input
              type="text"
              placeholder="Go#"
              className="form-control"
              value={customPaginationValue}
              onChange={handlePaginationChange}
              onInput={(e) => {
                // Only allow numbers
                e.target.value = e.target.value.replace(/[^0-9]/g, "");
              }}
              style={{
                padding: "0px 10px",
                color: "#878787",
                fontSize: 16,
                borderRadius: 5,
                border: "1px solid #A1B9ED",
                width: 60,
                height: 35,
                textAlign: "center",
              }}
            />
          </li>
        </ul>
      </nav>
    );
  };

  // PAGINATION
  const PagingData = ["10", "20", "50", "100"].map((item) => ({
    label: item,
    value: item,
  }));

  const handleClearFilters = () => {
    setCurrentPage(1);
    setSearchInput("");
    setSearchAsset("");
    setCountryCode("");
    setInvestmentamount("");
    setComplianceId("");
    setOrder("");
    setProgressId("");
    setScoreId("");
    setFilterDate(null);
    setScoreFrom(null);
    setScoreTo(null);
    setInvestmentFrom(null);
    setInvestmentTo(null);
    setSubscriptionId("");
  };

  const handleAssetClass = (value) => {
    setSearchAsset(value);
    setCurrentPage(1); // Reset to the first page for new search
  };

  const handleCountryChange = (value) => {
    setCurrentPage(1);
    setCountryCode(value);
  };

  const handleInvestmentChange = (value) => {
    if (!value) {
      setInvestmentamount(null);
      setInvestmentFrom(null);
      setInvestmentTo(null);
      return;
    }

    setInvestmentamount(value);

    // Remove $ and +, then split by '-'
    const cleanedValue = value.replace(/\$/g, "").replace(/\+/g, "").split("-");

    let investmentFrom = null;
    let investmentTo = null;

    if (cleanedValue.length === 2) {
      investmentFrom = parseInt(cleanedValue[0].replace(/,/g, "").trim(), 10);
      investmentTo = parseInt(cleanedValue[1].replace(/,/g, "").trim(), 10);
    } else {
      // For something like "$50,000+" → just one value
      investmentFrom = parseInt(cleanedValue[0].replace(/,/g, "").trim(), 10);
      investmentTo = null;
    }

    console.log("investmentFrom : " + investmentFrom);
    console.log("investmentTo : " + investmentTo);

    // Set your state values
    setInvestmentFrom(investmentFrom);
    setInvestmentTo(investmentTo);
  };

  const handleComplianceChange = (value) => {
    setCurrentPage(1);
    setComplianceId(value);
  };

  const handleProgressStatus = (value) => {
    setCurrentPage(1);
    setProgressId(value);
  };

   const handleUTMSource = (value) => {
    setCurrentPage(1);
    setUTMSourceId(value);
  };

  const handleScoreStatus = (value) => {
    setCurrentPage(1);

    if (!value) {
    setScoreId(null);
    setScoreFrom(null);
    setScoreTo(null);
    return;
  }

  setScoreId(value);

  // Remove $ and +, then split by '-'
  //const cleanedValue = value.split("-"); 
  const cleanedValue = value.split(/[-–—]/); // splits on hyphen, en dash, or em dash
  let scoreFrom = null;
  let scoreTo = null;
  

  
    scoreFrom = parseInt(cleanedValue[0].replace(/,/g, '').trim(), 10);
    scoreTo = parseInt(cleanedValue[1].replace(/,/g, '').trim(), 10);
  

  console.log('scoreFrom : ' + scoreFrom);
  console.log('scoreTo : ' + scoreTo);

  // Set your state values
  setScoreFrom(scoreFrom);
  setScoreTo(scoreTo);

  };

  const handleorderChange = (value) => {
    setCurrentPage(1);
    setOrder(value);
  };

  const [openDeletePopover, setOpenDeletePopover] = useState(null);
  const [publishSymbol, setPublishSymbol] = useState("");
  // Function to handle checkbox click
  const handleCheckboxClick = (item) => {
    // Toggle the popover visibility for the specific item
    setPublishSymbol(item.Symbol);
    if (openDeletePopover === item.id) {
      setOpenDeletePopover(null); // Close the popover if it's already open
    } else {
      setOpenDeletePopover(item.id); // Open the popover
    }
  };

  // // Function to handle deletion confirmation
  // const handlePublishConfirm = (Symbol) => {

  //     console.log(`Publish report with Symbol: ${Symbol}`);
  //     setOpenDeletePopover(null); // Close the popover after confirmation
  // };

  const handlePublishConfirm = (item) => {
    // console.log(`Publish report with Symbol: ${Symbol}`);

    // Prepare the data to be sent in the API request
    const requestData = {
      data: {
        user_id: userid, // Replace with actual user_id if needed
        symbol: item.Symbol, // Use the symbol passed to the function
        publish: item.Published ? "false" : "true",
      },
    };

    setOpenDeletePopover(null); // Close the popover after confirmation
  };

  // Store last known order in a ref or state, including hidden columns
  const [columnOrder, setColumnOrder] = useState([]);
  const [fullColumnOrder, setFullColumnOrder] = useState([]);

  // Populate fullColumnOrder initially
  useEffect(() => {
    setFullColumnOrder((prev) => {
      // Only set if it's empty (i.e., first load)
      return prev.length === 0 ? columnOrder : prev;
    });
  }, [columnOrder]);

 const handleCheckboxChange = async (columnName, isChecked) => {
  setColumnOrder((prevColumnOrder) => {
    // Step 1: Create a map of current states (from fullColumnOrder and prevColumnOrder)
    const currentColumnStates = new Map();

    fullColumnOrder.forEach((col) => {
      currentColumnStates.set(col.name, {
        is_active: col.is_active ?? true,
        is_draggable: col.is_draggable ?? col.isDraggable ?? true,
      });
    });

    prevColumnOrder.forEach((col) => {
      currentColumnStates.set(col.name, {
        is_active: col.is_active ?? true,
        is_draggable: col.is_draggable ?? col.isDraggable ?? true,
      });
    });

    // Step 2: Build the updated full column list
    const updatedColumnOrder = fullColumnOrder.map((col) => {
      const currentState = currentColumnStates.get(col.name);

      return {
        name: col.name,
        is_active: col.name === columnName ? isChecked : currentState?.is_active ?? true,
        is_draggable: currentState?.is_draggable ?? col.is_draggable ?? col.isDraggable ?? true,
      };
    });

    // Step 3: Update full state and call API
    setFullColumnOrder(updatedColumnOrder);
    saveColumnOrderToAPI(updatedColumnOrder);

    // Step 4: Return only active columns for UI state
    return updatedColumnOrder.filter((col) => col.is_active);
  });
};


  const saveColumnOrderToAPI = async (updatedColumnOrder) => {
  try {
    const cleanedPayload = updatedColumnOrder.map((col) => ({
      name: col.name,
      is_active: col.is_active,
      is_draggable: col.is_draggable,
    }));

    const response = await fetch(`${apiEndPoint}/update_user_column_order`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        data: {
          user_id: userid,
          module: "investers",
          column_order: cleanedPayload,
        },
      }),
    });

    fetchGlobalReport();

    if (!response.ok) throw new Error("Failed to save column order");
    const result = await response.json();
    // console.log("Column order updated successfully", result);
  } catch (error) {
    console.error("Error updating column order:", error);
  }
};


  const checkboxColumnMap = {
    JointHolderName: "Joint Holder Name",
    Email: "Email Address",
    PhoneNumber: "Phone Number",
    CountryofResidence: "Country",
    LocalTime: "Local Time",
    InvestmentLikelihoodScore: "Likehood Score",
    InvestmentInviteDate: "Investment Invite Date",
    TimeToFirstContact: "Time to First Contact",
    TotalInvestedAmount: "Total Invested Amount",
    AssignedUser: "Assigned User",
    IRNotes: "IR Notes",

    Source: "Source",
    UTMSource: "UTM Source",
    UTMMedium: "UTM Medium",
    UTMCampaign: "UTM Campaign",
    ReferralCode: "Referral code",

    PlatformUserType: "Platform User Type",
    PlatformUsageStatus: "Platform Usage Status",
    AppUserSince: "App User Since",
    WebUserSince: "Web User Since",
    PlatformRegistrationDate: "Platform Registration Date",
    LastActiveDate: "Last Active Date",
    TotalDaysActive: "Total Days Active",

    SubscriptionTier: "Subscription Tier",
    DaysInCurrentSubscription: "Days in Current Subscription",

    DaysBetweenSignupAndInvite: "Days Between Signup and Invite",
    EngagementScore: "Engagement Score",
    InvestmentAccountNumbers: "Investment Account Numbers",
    RegulationTypes: "Regulation Types",
    AccreditedInvestorStatus: "Accredited",
    DealmakerCertificate: "Dealmaker Certificate",
    SignedDate: "Signed Date",
    AcceptedDate: "Accepted Date",
    TimeSinceSubscription : "Time Since Subscription",

    NumberOfInvestments: "Number of Investments",
    InvestmentCurrency: "Investment Currency",
    InitialShares: "Initial Shares",
    WeightedAverageShares: "Weighted Average Shares",
    EstimatedPortfolioValue: "Estimated Portfolio Value",
    ValuationBasis: "Valuation Basis",
    TimeBasedBonusShares: "Time-Based Bonus Shares",
    AmountBasedBonusShares: "Amount-Based Bonus Shares",
    RepeatInvestorBonus: "Repeat Investor Bonus",
    PremiumSubscriberBonus: "Premium Subscriber Bonus",
    EventBasedBonus: "Event Based Bonus",
    TotalBonusShares: "Total Bonus Shares",

    Notes: "Notes",
    MailingAddress: "Mailing Address",
    Certificate: "certificate",
    ConfigureBonus:"Configure Bonus"
  };

  const handleReset = () => {
    // Create reset columns with all columns active and draggable
    const fullResetColumns = defaultColumns.map((name) => ({
      name,
      is_active: true,
      is_draggable: true,
    }));

    // Update both states
    setColumnOrder(fullResetColumns);
    setFullColumnOrder(fullResetColumns);

    // Save to API - this will send all columns with is_active: true and is_draggable: true
    saveColumnOrderToAPI(fullResetColumns);
  };

  // ✅ Save Column Order (separate API)
  const saveColumnOrder = async (newOrder) => {
    try {
      const formattedOrder = newOrder.map((col) => ({
        name: col.name,
        is_active: true,
        is_draggable: col.isDraggable ?? true,
      }));

      const response = await fetch(`${apiEndPoint}/update_user_column_order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            user_id: userid,
            module: "investers",
            column_order: formattedOrder,
          },
        }),
      });

      if (!response.ok) throw new Error("Failed to save column order");

      const result = await response.json();

       // ✅ Important: Update fullColumnOrder too!
    const updatedFullColumnOrder = formattedOrder.map((col) => ({
      ...col,
      is_active: col.is_active,
      is_draggable: col.is_draggable,
    }));

    setFullColumnOrder(updatedFullColumnOrder);

    // ✅ Also update visible columns
    setColumnOrder(updatedFullColumnOrder.filter((col) => col.is_active));

    // Optionally re-fetch data
    fetchGlobalReport();

      // console.log("Column order saved successfully:", result);
    } catch (error) {
      console.error("Error saving column order:", error);
    }
  };

  // REODER DRAG COLUMNS
  useEffect(() => {
    // console.log("Column Order Set:", columnOrder);
  }, [columnOrder]);

  const [open, setOpen] = useState(false);
  const [CMPTopen, setCMPTOpen] = useState(false);
  const [NCMPTopen, setNCMPTOpen] = useState(false);
  const [DBFTopen, setDBFTOpen] = useState(false);
  const [Intrestopen, setIntrestOpen] = useState(false);
  const [DEBTopen, setDEBTOpen] = useState(false);

  //const toggleDropdown = () => setOpen(!open); // Toggle dropdown visibility
  const preventClose = (e) => e.stopPropagation();

  const hideMessage = () => {
    setMessageType(null);
  };

  // Error Message

  const renderMessage = () => {
    if (messageType) {
      setTimeout(hideMessage, 5000);
    }

    switch (messageType) {
      case "success":
        return (
          <Message
            type="success"
            closable
            style={{
              display: "flex",
              alignItems: "center",
              width: "auto",
              position: "absolute",
              right: 0,
              top: 10,
              zIndex: 999,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <div className="icon_error_msg Icon_success">
                <div className="icon_error_msg_inner Icon_success_inner">
                  <img src={IconCheckError} alt="Success Icon" />
                  <div className="progress-circle progress_circle_success"></div>
                </div>
              </div>
              <div className="error_msg_text error_msg_success_text">
                <h5>Success</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      case "error":
        return (
          <Message
            type="error"
            closable
            style={{
              display: "flex",
              alignItems: "center",
              width: "auto",
              position: "absolute",
              right: 0,
              top: 10,
              zIndex: 999,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <div className="icon_error_msg Icon_error">
                <div className="icon_error_msg_inner Icon_error_inner">
                  <img src={IconError} alt="Error Icon" />
                  <div className="progress-circle progress_circle_error"></div>
                </div>
              </div>
              <div className="error_msg_text error_msg_error_text">
                <h5>Error</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      case "info":
        return (
          <Message
            type="info"
            closable
            style={{
              display: "flex",
              alignItems: "center",
              width: "auto",
              position: "absolute",
              right: 0,
              top: 10,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
              <div className="icon_error_msg Icon_info">
                <div className="icon_error_msg_inner Icon_info_inner">
                  <img src={IconInfo} alt="Info Icon" />
                  <div className="progress-circle progress_circle_info"></div>
                </div>
              </div>
              <div className="error_msg_text error_msg_info_text">
                <h5>Info</h5>
                <p>{errorMessage}</p>
              </div>
            </div>
          </Message>
        );
      default:
        return null;
    }
  };

  // MODAL
  const [commentLoading, setCommentLoading] = useState(false);
  const [commentFetchTextValue, setCommentFetchTextValue] = useState("");
  const [commentFieldId, setCommentFieldId] = useState(null);
  const [commentCount, setCommentCount] = useState(0);
  const [commentdata, setCommentData] = useState([]);
  const [errorMessage1, setErrorMessage1] = useState("");
  const [messageType1, setMessageType1] = useState("");
  const [isBox1Visible, setIsBox1Visible] = useState(false);

  const [EditModalOpen, setEditModalOpen] = useState(false);
  const [editModalETFName, setEditModalETFName] = useState("");
  const [editModalETFSymbol, setEditModalSymbol] = useState("");
  const etfModelCommentRef = useRef(null);
  const [etfModelPublicComment, setEtfModelPublicComment] = useState("");
  const [etfModelPrivateComment, setEtfModelPrivateComment] = useState("");
  const [isModalETFLoading, setIsModalETFLoading] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(0);
  const [selectedFileInvestorId, setSelectedFileInvestorId] = useState();


    const fetchReassignHistory = async (item) => {
        const requestData = encryptData({
          data: {
            user_id: userid,
            investor_id: item.id,
          },
        });

  try {
    const response = await fetch(`${apiEndPoint}/reassign_history`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: requestData,
    });

    if (!response.ok) {
      throw new Error("Network response was not ok " + response.statusText);
    }

    const data = await response.json();
    const decrypted = decryptData(data);

    if (decrypted.status == "success") {
      console.log("Count:", decrypted.count);
      console.log("Data:", decrypted.data);

      setReassignCount(decrypted.count);
      setReassignHistory(decrypted.data);

    } else {
       setReassignCount(0);
      setReassignHistory([]);
      console.error("Error:", decrypted.message);
    }
  } catch (error) {
    console.error("Fetch error:", error.message);
  }
};

  const handleEditModalOpen = (item) => {
    setAssignUserid(item.user_in_charge_id);
    setAssignUserComment(item.user_comment);
    setSelectedInvestorId(item.id);

    setEditModalOpen(true);

   fetchReassignHistory(item);
    
  };



  const [commentBoxOpen, setCommentBoxOpen] = React.useState(false);
  const handleCommentBoxClose = () => setCommentBoxOpen(false);
  const [addCommentLoader, setAddCommentLoader] = useState(false);
  const [dateInvited, setDateInvited] = useState("");
  const [colorCode, setColorCode] = useState("");
  const [firstTimeToContact, setFirstTimeToContact] = useState("");
  const [reassignCount, setReassignCount] = useState(0);
  const [reassignHistory, setReassignHistory] = useState([]);



  const handleCommentBoxOpen = async (item) => {
    setCommentLoading(true);

    setDateInvited(item.invite_date);
    setColorCode(item.color_code);
    setFirstTimeToContact(item.time_to_first_comment);
    setCommentFetchTextValue(item.name);
    setCommentFieldId(item.id);

    setCommentBoxOpen(true);



    const requestData = encryptData({
      data: {
        user_id: userid,
        investor_id: item.id,
      },
    });

    //console.log(JSON.stringify(requestData));

    try {
      const response = await fetch(`${apiEndPoint}/get_comments`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: requestData,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
        setCommentLoading(false);
      }

      const data = await response.json();
      const decrypted = decryptData(data);

      console.log("A : " + JSON.stringify(decrypted));

      if (decrypted.status == "success") {
        setCommentLoading(false);
        console.log("Count:", decrypted.count);
        console.log("comments:", decrypted.data);
        setCommentCount(decrypted.count);
        setCommentData(decrypted.data);
      } else {
        setCommentLoading(false);
        toastIdRef.current = toast({
          description: decrypted.message,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        console.log("Response data:", data);
      }
    } catch (error) {
      setCommentLoading(false);
      console.error("There was a problem with the fetch operation:", error);
    }
  };

  const deleteComment = async (item) => {
    setCommentBoxOpen(true);

    const requestData = encryptData({
      data: {
        user_id: userid,
        comment_id: item.id,
        investor_id: item.investor_id,
      },
    });

    console.log(JSON.stringify(requestData));

    try {
      const response = await fetch(`${apiEndPoint}/delete_comment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: requestData,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok " + response.statusText);
      }

      const data = await response.json();
      const decrypted = decryptData(data);
      console.log(JSON.stringify(data));
      if (decrypted.status == "success") {
        console.log("Count:", decrypted.count);
        console.log("MESSAGE : " + JSON.stringify(decrypted.data));
        setCommentCount(decrypted.count);
        setCommentData(decrypted.data);
      } else {
        toastIdRef.current = toast({ description: decrypted.message, status: "error", duration: 5000, isClosable: true, position: "bottom", });
        console.log("Response data:", data);
      }
    } catch (error) {
      console.error(
        "There was a problem with the fetch operation:",
        error.message
      );
    }
  };

  const addComment = async () => {
    const message = document.getElementById("txtComment").value;
    setAddCommentLoader(true);
    //setCommentLoading(true);
    const url = `${apiEndPoint}/create_comment`;
    const request = encryptData({
      data: {
        user_id: userid,
        investor_id: commentFieldId,
        comment: message,
      },
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: request,
      });

      const data = await response.json();
      const decrypted = decryptData(data);

      if (decrypted.status == "success") {
        setAddCommentLoader(false);

        document.getElementById("txtComment").value = "";
        // setCommentLoading(false);
        if (decrypted.count == 1) {
          setRefreshKey((prev) => prev + 1);
        }
        console.log("Count:", decrypted.count);
        console.log("comments:", decrypted.data);
        setCommentCount(decrypted.count);
        setCommentData(decrypted.data);
      } else {
        setAddCommentLoader(false);
        document.getElementById("txtComment").value = "";
        //setCommentLoading(false);
        toastIdRef.current = toast({
          description: decrypted.message,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        return false;
        console.log("Response data:", data);
      }
      //setResponse(result);
    } catch (error) {
      setAddCommentLoader(false);
      document.getElementById("txtComment").value = "";
      //setCommentLoading(false);
      console.error("Error:", error);
    }
  };

  const [expandedRowId, setExpandedRowId] = useState(null);

  const handleRowClick = (id) => {
    console.log(expandedRowId + " : " + id);
    if (expandedRowId == id) {
      setExpandedRowId(null);
    } else {
      // Toggle the expanded row
      setExpandedRowId(id);
      //setExpandedRowId(prevId => (prevId === id ? null : id));
    }
  };

  const handleEditModalClose = () => setEditModalOpen(false);

  // const StatusData = ['Compliant', 'Non- Compliant', 'Doubtful', 'Uncovered'].map(
  //     item => ({ label: item, value: item })
  // );
  const StatusData = [
    "Zain Shaikh",
    "Sana Rizvi",
    "Ali Noor",
    "Rehan Qureshi",
    "Nida Sheikh",
  ].map((item) => ({
    label: item,
    value: {
      Compliant: "COMPLIANT",
      "Non- Compliant": "NON_COMPLIANT",
      Doubtful: "QUESTIONABLE",
      Uncovered: "NOT_UNDER_COVERAGE",
    }[item],
  }));

  //const CountryData = ['India', 'Saudi Arabia', 'USA', 'UAE', 'Pakistan'].map(item => ({ label: item, value: item }));

  const MembersData = [
    "Zain Shaikh",
    "Sana Rizvi",
    "Ali Noor",
    "Rehan Qureshi",
    "Nida Sheikh",
  ].map((item) => ({ label: item, value: item }));

  const InvestmentAmountData = [
    "$0 - $10,000",
    "$10,000 - $20,000",
    "$20,000 - $30,000",
    "$40,000 - $50,000",
    "$50,000+",
  ].map((item) => ({ label: item, value: item }));

  const SharesData = ["0 - 100", "101 - 500", "501 - 1,000"].map((item) => ({
    label: item,
    value: item,
  }));

  const progressStatus = [
    "Offline",
    "Online",
    "Signed",
    "Waiting",
    "Invited",
    "Accepted",
    "Inactive",
    "Progress",
  ].map((item) => ({ label: item, value: item }));

  const ScoreStatus = ["85–100", "70–84", "50–69", "0–49"].map((item) => ({
    label: item,
    value: item,
  }));

  const StatusData1 = [
    "Committed",
    "Funded",
    "Interest Express",
    "Cancelled",
    "Completed",
  ].map((item) => ({ label: item, value: item }));

  useEffect(() => {
    if (etfModelCommentRef.current) {
      etfModelCommentRef.current.value = etfModelPublicComment;
    }
  }, [etfModelPublicComment]);

  const handleManualSave = async () => {
    if (!selectedStatus) {
      setErrorMessage("Please select new compliance status");
      setMessageType("error");
      return false;
    }

    if (!etfModelPrivateComment) {
      setErrorMessage("Please add a Private comment before submitting.");
      setMessageType("error");
      return false;
    }
  };

  const handleManualReset = async () => {
    setIsModalETFLoading(true);
  };

  const handleFilterDateChange = (value) => {
    setCurrentPage(1);

    setFilterDate(value);
  };

  const handleETFStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption); // Update selectedPeriod state with the selected option
  };

  const triggerRef = React.useRef();
  const openUncovered = () => triggerRef.current.openUncovered();
  const closeUncovered = () => triggerRef.current.closeUncovered();

  // TRUNCATE
  function truncateText(text, maxLength = 14) {
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  }

  function address__truncate(text, maxLength = 22) {
    if (typeof text !== "string") return "-";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  }

  function notes__truncate(text, maxLength = 30) {
    if (typeof text !== "string") return "-";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  }

  // REODER DRAG COLUMNS
  // const [columnOrder, setColumnOrder] = useState([
  //   "Action",
  //   "Investor ID",
  //   "Full Name",
  //   "Joint Holder Name",
  //   "Email Address",
  //   "Phone Number",
  //   "Country",
  //   "Local Time",
  //   "Likehood Score",
  //   "Investment Invite Date",
  //   "Time to First Contact",
  //   "Total Invested Amount",
  //   "Assigned User",
  //   "IR Notes",

  //   "Source",
  //   "UTM Source",
  //   "UTM Medium",
  //   "UTM Campaign",
  //   "Referral code",
  //   "Platform User Type",
  //   "Platform Usage Status",
  //   "App User Since",
  //   "Web User Since",
  //   "Platform Registration Date",
  //   "Last Active Date",
  //   "Total Days Active",
  //   "Subscription Tier",
  //   "Days in Current Subscription",

  //   "Days Between Signup and Invite",
  //   "Engagement Score",
  //   "Investment Account Numbers",
  //   "Regulation Types",
  //   "Accredited",
  //   "Dealmaker Certificate",
  //   "Signed Date",
  //   "Accepted Date",

  //   "Number of Investments",
  //   "Investment Currency",
  //   "Weighted Average Shares",
  //   "Estimated Portfolio Value",
  //   "Valuation Basis",
  //   "Time-Based Bonus Shares",
  //   "Amount-Based Bonus Shares",
  //   "Repeat Investor Bonus",
  //   "Premium Subscriber Bonus",
  //   "Total Bonus Shares",
  //   "Notes",
  //   "Mailing Address",
  //   "certificate",
  // ]);

  const [draggedColumn, setDraggedColumn] = useState(null);

  const handleDragStart = (e, col) => {
    setDraggedColumn(col);

    const dragPreview = document.createElement("div");
    dragPreview.style.position = "absolute";
    dragPreview.style.top = "-9999px";
    dragPreview.style.padding = "6px 16px";
    dragPreview.style.background = "#FFD791";
    dragPreview.style.border = "1px solid #99bde0";
    dragPreview.style.borderRadius = "4px";
    dragPreview.style.color = "#000";
    dragPreview.style.fontSize = "16px";
    dragPreview.style.fontWeight = "bold";
    dragPreview.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.15)";
    dragPreview.textContent = col;

    document.body.appendChild(dragPreview);
    e.dataTransfer.setDragImage(dragPreview, 0, 0);

    // Cleanup
    setTimeout(() => {
      document.body.removeChild(dragPreview);
    }, 0);
  };

  // const handleDrop = (e, targetCol) => {
  //   e.preventDefault();
  //   const fromIndex = columnOrder.indexOf(draggedColumn);
  //   const toIndex = columnOrder.indexOf(targetCol);

  //   if (fromIndex === -1 || toIndex === -1 || fromIndex === toIndex) return;

  //   const newOrder = [...columnOrder];
  //   const [moved] = newOrder.splice(fromIndex, 1);
  //   newOrder.splice(toIndex, 0, moved);

  //   const thElements = document.querySelectorAll("th");
  //   const tdElements = document.querySelectorAll("tbody tr");

  //   // FLIP: First — Get starting positions
  //   const firstPositions = {};
  //   columnOrder.forEach((key) => {
  //     const th = document.querySelector(`th[data-column-id="${key}"]`);
  //     if (th) firstPositions[key] = th.getBoundingClientRect().left;
  //   });

  //   setColumnOrder(newOrder); // Update DOM

  //   // Wait for re-render
  //   requestAnimationFrame(() => {
  //     // Animate headers (FLIP)
  //     newOrder.forEach((key) => {
  //       const th = document.querySelector(`th[data-column-id="${key}"]`);
  //       const oldX = firstPositions[key];
  //       if (!th || oldX === undefined) return;

  //       const newX = th.getBoundingClientRect().left;
  //       const dx = oldX - newX;

  //       if (dx !== 0) {
  //         th.style.transform = `translateX(${dx}px)`;
  //         th.classList.add("animating");

  //         requestAnimationFrame(() => {
  //           th.style.transform = "";
  //         });

  //         setTimeout(() => {
  //           th.classList.remove("animating");
  //         }, 400);
  //       }
  //     });

  //     // Animate movedColumn cells
  //     const movedColumn = draggedColumn; // dynamically get the dragged column id
  //     const cells = document.querySelectorAll(`[data-column-id="${movedColumn}"]`);
  //     cells.forEach((cell) => {
  //       void cell.offsetWidth; // force reflow to restart animation
  //       cell.classList.add("column-drop-animate");
  //     });

  //     setTimeout(() => {
  //       cells.forEach((cell) => {
  //         cell.classList.remove("column-drop-animate");
  //       });
  //     }, 850);

  //   });

  //   setDraggedColumn(null);
  // };

  const handleDragOver = (e) => {
    e.preventDefault(); // Required to allow drop
  };

  // 🟩 Drag end
  const handleDragEnd = () => {
    setDraggedColumn(null);
  };

  const handleDrop = (e, targetColumnKey) => {
    // console.log("Drop event triggered for column:", targetColumnKey);
    e.preventDefault();

    const draggedIndex = columnOrder.findIndex(
      (col) => col.name === draggedColumn
    );
    const targetIndex = columnOrder.findIndex(
      (col) => col.name === targetColumnKey
    );

    if (
      draggedIndex === -1 ||
      targetIndex === -1 ||
      draggedIndex === targetIndex
    ) {
      setDraggedColumn(null);
      return;
    }

    // Temporarily disable scrollbar during animation
    const tableContainer = document.querySelector(".table").closest("div");
    if (tableContainer) {
      tableContainer.style.overflowY = "hidden";
    }

    const newColumnOrder = [...columnOrder];
    const [movedColumn] = newColumnOrder.splice(draggedIndex, 1);
    newColumnOrder.splice(targetIndex, 0, movedColumn);

    setColumnOrder(newColumnOrder);
    setDraggedColumn(null);
    saveColumnOrder(newColumnOrder);

    // Apply drop animation with performance optimizations
    requestAnimationFrame(() => {
      // Find all cells with the movedColumn's data-column-id
      const cells = document.querySelectorAll(
        `[data-column-id="${movedColumn.name}"]`
      );

      // Get current table height to lock it during animation
      const table = document.querySelector("table");
      const tableHeight = table.offsetHeight;
      table.style.height = `${tableHeight}px`;

      cells.forEach((cell) => {
        // Force reflow to ensure animation restarts
        void cell.offsetWidth;
        cell.classList.add("column-drop-animate");
      });

      // Cleanup after animation completes
      setTimeout(() => {
        cells.forEach((cell) => {
          cell.classList.remove("column-drop-animate");
        });

        // Release table height constraint
        table.style.height = "";

        // Re-enable vertical scrolling if needed
        if (tableContainer) {
          tableContainer.style.overflowY = "";
        }

        // Optional: Highlight the table
        table.classList.add("table-highlight-column");
        setTimeout(() => {
          table.classList.remove("table-highlight-column");
        }, 600);
      }, 850); // Slightly longer than animation duration
    });
  };

  const [open2, setOpen2] = useState(false);

  const handleOpenDrawer = () => setOpen2(true);
  const handleCloseDrawer = () => setOpen2(false);

  function formatPhoneNumberGlobal(rawNumber) {
    if (!rawNumber) return rawNumber;
    const phoneNumber = parsePhoneNumberFromString(rawNumber);
    return phoneNumber
      ? phoneNumber.formatInternational().replace(/\s+/g, "-")
      : rawNumber;
  }

  const [times, setTimes] = useState({});

  // useEffect(() => {
  //   const updateTimes = () => {
  //     const newTimes = {};
  //     // Iterating to each country (just using "code")
  //     countries.forEach(({ code }) => {
  //       const tzs = countryTz.getTimeZonesByCode(code); // We will get timezone of that country code
  //       const tz = tzs && tzs.length ? tzs[0] : null; // if both true than only continue

  //       if (tz) {
  //         const timeStr = new Intl.DateTimeFormat("en-US", {
  //           timeZone: tz,
  //           hour: "2-digit",
  //           minute: "2-digit",
  //           second: "2-digit",
  //           hour12: false,
  //         }).format(new Date());
  //         newTimes[code] = { time: timeStr, timezone: tz };

  //       } else {
  //         newTimes[code] = { time: "N/A", timezone: "N/A" };
  //       }
  //     });

  //     setTimes(newTimes);
  //   };

  //   updateTimes(); // initial call
  //   const interval = setInterval(updateTimes, 1000); //Refetches time after 1 seconds
  //   return () => clearInterval(interval);
  // }, []);

  const getTimeForTimezone = (timezone) => {
    if (!timezone) return "N/A";

    return new Intl.DateTimeFormat("en-US", {
      timeZone: timezone,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    }).format(new Date());
  };

  // New component to show continuously updating time
  const LiveTimeCell = ({ timezone }) => {
    const [time, setTime] = useState(getTimeForTimezone(timezone));

    useEffect(() => {
      const interval = setInterval(() => {
        setTime(getTimeForTimezone(timezone));
      }, 1000); // update every second

      return () => clearInterval(interval); // cleanup
    }, [timezone]);

    return <td>{time}</td>;
  };

  const handleReassignSave = async () => {
    if (!assignUserid || assignUserid == 0) {
      toastIdRef.current = toast({ description: "Please Select User", status: "error", duration: 5000, isClosable: true, position: "bottom", });
      return false;
    }

    try {
      setLoading(true);
      const apiUrl = `${apiEndPoint}/reassign_user`;
      const requestData = encryptData({
        data: {
          investor_id: selectedInvestorId,
          new_user_assign_id: assignUserid,
          updated_by: userid,
          comment: assignUserComment,
        },
      });

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: requestData,
      });

      const jsonData = await response.json();
      const decrypted = decryptData(jsonData);

      if (decrypted.status == "success") {
        setLoading(false);
        setRefreshKey((prev) => prev + 1);
        toastIdRef.current = toast({
          description: decrypted.message,
          status: "success",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        setEditModalOpen(false);
      } else {
        setLoading(false);
        toastIdRef.current = toast({
          description: decrypted.message,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        return false;
      }
    } catch (error) {
      setLoading(false);
      toastIdRef.current = toast({
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
        position: "bottom",
      });
      return false;
    }
  };

  const [uploadedfileList, setUploadedFileList] = useState([]);
  const [progress, setProgress] = useState({});
  const [timeRemaining, setTimeRemaining] = useState({});
  const [preview, setPreview] = useState("");
  const [reportType, setReportType] = useState("");

  const [showUploadManualModal, setUploadManualModal] = useState(false);
  const closeUploadManualModal = () => setUploadManualModal(false);

  const [showUploadpreviewModal, setUploadpreviewModal] = useState(false);
  const closeUploadpreviewModal = () => setUploadpreviewModal(false);

  const handleRemove = async (file) => {
    console.log("Removed file:", file);

    const url = `${apiEndPoint}/delete_investor_file`;

    const requestData = encryptData({
      data: {
        user_id: userid,
        investor_id: selectedFileInvestorId,
      },
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: requestData,
      });

      const result = await response.json();
      const data = decryptData(result);
      console.log("API Response:", data);

      if (data?.status === true) {
        console.log("File deleted successfully:", file.fileKey);

        // const newFiles = data.data.files.map((file) => ({
        //   id : file.id,
        //   name: file.title,
        //   fileKey: file.id,
        //   url: file.file_url,
        //   type : file.file_type,
        //   size : file.file_size,
        // }));
        setUploadedFileList([]);
      } else {
        console.error(
          "Failed to delete file:",
          data?.status || "Unknown error"
        );
      }

      // Agar API success response de to file list se remove karne ka logic yahan likho
    } catch (error) {
      console.error("Error deleting file:", error);
    }
  };

  const handleUploadClick = async (item) => {
    setUploadedFileList([]);
    setSelectedFileInvestorId(item.id);
    try {
      const response = await fetch(`${apiEndPoint}/get_investor_file`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: encryptData({
          data: {
            investor_id: item.id,
            user_id: userid,
          },
        }),
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await response.json();
      const data = decryptData(result);
      const responseData = data?.data?.data;

      if (
        data?.data?.status === "success" &&
        ((Array.isArray(responseData) && responseData.length > 0) ||
          (!Array.isArray(responseData) && responseData))
      ) {
        const filesArray = Array.isArray(responseData)
          ? responseData
          : [responseData];

        const newFiles = filesArray.map((file) => ({
          id: file.id,
          name: file.title,
          fileKey: file.id,
          url: file.file_url,
          type: file.file_type,
          size: file.file_size,
        }));

        setUploadedFileList(newFiles);
      }

      // if (data.data.status == "success" && data?.data?.data) {
      //   const filesArray = Array.isArray(data.data.data) ? data.data.data : [data.data.data];

      //   const newFiles = filesArray.map((file) => ({
      //     id : file.id,
      //     name: file.title,
      //     fileKey: file.id,
      //     url: file.file_url,
      //     type : file.file_type,
      //     size : file.file_size,
      //   }));

      //  // setUploadedFileList((prev) => [...prev, ...newFiles]);

      //  console.log(newFiles);
      //  setUploadedFileList(newFiles);

      // }

      setUploadManualModal(true);
      //setFiles(result.data); // API response ke `data` ko store kar rahe hain
      //  console.log("Files:", data);
    } catch (error) {
      console.error("Error fetching task files:", error.message);
    }
  };

  const handlePreviewClick = (file) => {
    console.log(file);
    setReportType(file.type);
    setPreview(file.url);
    setUploadpreviewModal(true);
  };

 const [editModalBonusOpen, setEditModalBonusOpen] = useState(false);
 const handleEditBonusModalOpen = () => setEditModalBonusOpen(true);
 const handleEditBonusModalClose = () => setEditModalBonusOpen(false);


  const handleAddBonus = (item) => {
    setSelectedFileInvestorId(item.id);
    setAmountBonus(item.amount_based_bonus);
    setTimeBonus(item.time_based_bonus);
    setEventBonus(item.event_based_bonus);
    setExistingBonus(item.existing_investor_bonus);
    setPremiumBonus(item.premium_subscription_bonus);
    setTotalBonus(item.total_bonus);
    setEditModalBonusOpen(true);
  };

  // Function to handle file selection and upload
  const handleFileSelect = async (file) => {
    if (!file || !file.blobFile) return;

    const newFile = {
      file: file.blobFile,
      name: file.name,
      url: URL.createObjectURL(file.blobFile),
      startTime: Date.now(),
      progress: 0,
      status: "Uploading...", // Initial status
    };

    setUploadedFileList((prevFiles) => [...prevFiles, newFile]); // Append new file to list
    await uploadFile(newFile);
  };

  // Function to upload files to the API
  const uploadFile = async (fileObj) => {
    setProgress((prev) => ({ ...prev, [fileObj.name]: 0 }));

    const requestData = encryptData({
      data: {
        investor_id: selectedFileInvestorId,
        user_id: userid,
        title: fileObj.name,
      },
    });

    const formData = new FormData();
    formData.append("data", requestData);
    formData.append("files", fileObj.file);

    let progressValue = 0;
    const startTime = Date.now();

    // Fake progress update every 500ms
    const interval = setInterval(() => {
      progressValue += Math.random() * 10; // Random increment
      progressValue = Math.min(progressValue, 95); // Max 95% tak jayega

      setProgress((prev) => ({
        ...prev,
        [fileObj.name]: Math.round(progressValue),
      }));
    }, 500);

    try {
      const response = await fetch(`${apiEndPoint}/upload_investor_files`, {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      console.log(`Upload Success: ${fileObj.name}`, result);
      const data = decryptData(result);
      console.log(data.data?.status);

      if (data.data?.status === "success" && data?.data?.files?.length > 0) {
        const newFiles = data?.data?.files.map((file) => ({
          id: file.id,
          name: file.title,
          fileKey: file.id,
          url: file.file_url,
          type: file.file_type,
          size: file.file_size,
        }));
        setUploadedFileList(newFiles);
      } else if (data?.status === "error") {
        setUploadedFileList([]);

        toastIdRef.current = toast({
          description: data?.message,
          status: "error",
          duration: 5000,
          isClosable: true,
          position: "bottom",
        });
        return false;

        // setErrorMessage(result?.data?.message);
        // setMessageType('error');
      }

      // Once upload completes, set progress to 100%
      setProgress((prev) => ({ ...prev, [fileObj.name]: 100 }));
    } catch (error) {
      console.error(`Upload Failed: ${fileObj.name}`, error);
    } finally {
      clearInterval(interval); // Stop progress updates
    }
  };

  const getFileIcon = (fileType) => {
    if (fileType.includes("jpeg") || fileType.includes("jpg")) return iconJPG;
    if (fileType.includes("png")) return iconPNG;
    if (fileType.includes("pdf")) return iconPDF;
    return null;
  };

   const [open3, setOpen3] = useState(false);
  
    // const handleConfirm = () => {
    //   onDelete(item.id); // delete logic from parent
    //   setOpen(false);
    // };
  
    const handleCancel = () => {
      setOpen3(false);
    };
  
    const renderSpeaker = (
      <Popover className="common__popover lead__popover" preventOverflow>
        <div className="tooltip_form_inner text-center">
          <div
            style={{
              fontSize: 18,
              color: "#141B3C",
              fontWeight: 500,
              lineHeight: 1.3,
            }}
          >
            Are you sure you want to delete this report ?
          </div>
  
          <div className="btn__group mt-5">
            <a href="#" className="btn__cancel" onClick={handleCancel}>
              Cancel
            </a>
            <a href="#" className="btn__assign" onClick={handleCancel}>
              Delete
            </a>
          </div>
        </div>
      </Popover>
    );

    const priorityClassMap = {
    'Medium': 'table_icon_medium',
    'Low': 'table_icon_low',
    'Very Low': 'table_icon_very_low',
    'High': 'table_icon_high',
    'Very High': 'table_icon_very_high'
  };

  const handleSaveBonus = async () => {

    const bonuses = [AmountBonus, TimeBonus, EventBonus, ExistingBonus, PremiumBonus];
    const total = bonuses.reduce((sum, val) => sum + (parseFloat(val) || 0), 0);
    const total_bonus_shares = Math.ceil(total);

  const payload = {
    investor_id: selectedFileInvestorId,
    bonus_breakdown: [
      { label: "Amount-Based", key: "amount_based", value: AmountBonus },
      { label: "Time-Based", key: "time_based", value: TimeBonus },
      { label: "Event-Based (Ramadan)", key: "event_based", value: EventBonus },
      { label: "Existing Investor", key: "existing_investor", value: ExistingBonus},
      { label: "Existing Premium User", key: "existing_premium_user", value: PremiumBonus }
    ],
    total_bonus_shares: total_bonus_shares || 0,
  };

  try {
    const response = await fetch(`${apiUrl}/api/dealmaker/investor-bonus?X-API-Key=${apiKey}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': apiKey
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();

    if (data.status) {
      const bonusData = data.data.investor_bonus;
      setRefreshKey((prev) => prev + 1);
      toastIdRef.current = toast({ description: data.message, status: "success", duration: 5000, isClosable: true, position: "bottom", });
      handleEditBonusModalClose();
      //console.log('Bonus saved successfully:', bonusData);
      // TODO: Show success toast or update state
    } else {
      console.error('Failed to save bonus:', data.message);
      // Show validation error if available
  const errorMessages = data.errors
    ? Object.entries(data.errors).map(
        ([field, messages]) => `${field}: ${messages.join(', ')}`
      ).join('\n')
    : data.message;

      toastIdRef.current = toast({ description: errorMessages, status: "error", duration: 5000, isClosable: true, position: "bottom", });
      // TODO: Show error toast/message
    }

  } catch (error) {
    toastIdRef.current = toast({ description: error.message, status: "error", duration: 5000, isClosable: true, position: "bottom", });
    console.error('Error while calling bonus API:', error);
    // TODO: Show error message in UI
  }
};

// utility function
const handleNumberInputChange = (value, setter) => {
  if (value === '' || /^\d*\.?\d*$/.test(value)) {
    setter(value);
  }
};



  return (
    <>
      <Sidebar />
      <ChakraProvider resetCSS={false}>
        {" "}
        <Wrap> </Wrap>{" "}
      </ChakraProvider>

      <div id="header">
        {renderMessage()}
        <div className="logo">
          <div className="logo_icon">
            <img src={Logo} />
          </div>
          <div className="brand_name">Investors </div>
        </div>

        <div className="header_table_filter LeadFilter">
          <div className="searchfield">
            <button className="btn_search">
              <i className="icon-search2"></i>
            </button>
            <input
              type="text"
              className="filter_searchfield"
              placeholder="Search"
              onChange={handleSearch}
              value={searchInput}
            />
          </div>

          <div className="dropdown_style filter_by_country">
            <SelectPicker
              data={countryData}
              searchable={true}
              // style={{ width: 150 }}
              placeholder="Country"
              onChange={handleCountryChange}
              value={countryCode}
            />
          </div>

          <div className="dropdown_col_filter dropdown__select">
            <SelectPicker
              data={subscriptionData}
              searchable={false}
              // style={{ width: 120 }}
              placeholder="Subscription"
              onChange={handleSubscription}
              value={subscriptionId}
            />
          </div>

          <div className="dropdown_col_filter dropdown__select">
            <SelectPicker
              data={InvestmentAmountData}
              searchable={false}
              // style={{ width: 130 }}
              placeholder="Investments"
              onChange={handleInvestmentChange}
              value={investmentamount}
            />
          </div>
          {/* 
          <div className='dropdown_col_filter dropdown__select'>
            <SelectPicker
              data={progressStatus}
              searchable={false}
              style={{ width: 180 }}
              placeholder="Select Progress State"
              onChange={handleProgressStatus}
              value={progressId}
            />
          </div> */}

          <div className="dropdown_col_filter dropdown__select">
            <SelectPicker
              data={ScoreStatus}
              searchable={false}
              // style={{ width: 80 }}
              placeholder="Score"
              onChange={handleScoreStatus}
              value={scoreId}
            />
          </div>

           <div className="dropdown_col_filter dropdown__select">
            <SelectPicker
              data={UTMSourceData}
              searchable={false}
              // style={{ width: 160 }}
              placeholder="Source"
              onChange={handleUTMSource}
              value={UTMSourceId}
            />
          </div>

          <div className="dropdown_col_filter dropdown__select">
            <DatePicker
              oneTap
              style={{ width: 160 }}
              placeholder="Choose Date"
              format="dd-MM-yyyy"
              value={filterDate}
              onChange={handleFilterDateChange}
            />
          </div>

          {/* <div className='dropdown_style'>
                <SelectPicker
                    data={data}
                    searchable={false}
                    style={{ }}
                    placeholder="All Compliance statuses"
                    />
            </div>
            <div className='dropdown_style'>
                <SelectPicker
                    data={data}
                    searchable={false}
                    style={{ }}
                    placeholder="Both Publish Statuses"
                    />
            </div> */}

          <a
            href="javascript:void(0)"
            className="btn_clear_filter"
            style={{ textDecoration: "none", width:'auto' }}
            onClick={handleClearFilters}
          >
            Clear
          </a>
        </div>
      </div>
      <div className="container-fluid content pb-5">
        <div className="company_table_list" data-aos="fade-up" data-aos-duration="800" >
          {globalLoading && ( <Placeholder.Grid rows={20} columns={9} active style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 12 }} /> )}

          {/* Table */}
          {!globalLoading && (
            <>
              <div className="table-responsive clsPagingWrap">
                <table className="table table__iri__sticky table__lead__sticky">
                  <thead>
                    <tr>
                      {columnOrder.map((col) => {
                        if (col.name === "Action") {
                          return (
                            <th
                              className="sticky-col left-col-1 waitlist_id_col"
                              style={{ textAlign: "center" }}
                            >
                              Action
                            </th>
                          );
                        }
                        if (col.name === "Investor ID") {
                          return (
                            <th
                              className="sticky-col left-col-2 waitlist_id_col"
                              key={col.name}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <span>Investor ID</span>{" "}
                                <Button className="btn__refresh_header">
                                  <img
                                    src={IconRefresh}
                                    onClick={fetchGlobalReport}
                                  />
                                </Button>
                              </div>
                            </th>
                          );
                        }

                        if (col.name === "Full Name") {
                          return (
                            <th
                              className="sticky-col left-col-3"
                              key={col.name}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 12,
                                }}
                              >
                                <span>Name</span>
                                <Button
                                  className="btn__cell_show"
                                  onClick={handleOpenDrawer}
                                >
                                  <img src={IconEye} />
                                </Button>
                              </div>
                            </th>
                          );
                        }
                        if (col.name === "Joint Holder Name") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Joint Holder Name</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                <div className="cls_cell_Flex">
                                  <span>Holder Name</span>
                                  {/* <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>The data has not been tested</Tooltip>}><span className='cls_orange_dot'></span></Whisper> */}
                                </div>
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Email Address") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              <div className="cls_cell_Flex">
                                <span>Email</span>
                                {/* <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>The data has not been tested</Tooltip>}><span className='cls_orange_dot'></span></Whisper> */}
                              </div>
                            </th>
                          );
                        }
                        if (col.name === "Phone Number") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              {" "}
                              <div className="cls_cell_Flex">
                                <span>Phone</span>
                                {/* <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>The data is not reliable</Tooltip>}><span className='cls_red_dot'></span></Whisper> */}
                              </div>
                            </th>
                          );
                        }
                        if (col.name === "Country") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Country</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                Country
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Local Time") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              Local Time
                            </th>
                          );
                        }
                        if (col.name === "Investment Invite Date") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Investment Invite Date</Tooltip>
                              }
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Invite Date
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Time to First Contact") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              onClick={() => handleIconClick("created_at")}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              Time to First Contact
                            </th>
                          );
                        }
                        if (col.name === "Likehood Score") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Investment Likehood Score</Tooltip>
                              }
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                <div className="cls_cell_Flex">
                                  <span>Score</span>
                                  
                                </div>
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Total Invested Amount") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Total Invested Amount</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                onClick={() =>
                                  handleIconClick("investment_amount")
                                }
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Amount{" "}
                                <img
                                  src={isAscending2 ? icon2_Asc : icon2_Desc}
                                  style={{ height: 16, marginLeft: 10 }}
                                  alt={
                                    isAscending2
                                      ? "Ascending Icon"
                                      : "Descending Icon"
                                  }
                                ></img>
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Assigned User") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              Assigned User
                            </th>
                          );
                        }
                        if (col.name === "IR Notes") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              IR Notes
                            </th>
                          );
                        }

                        if (col.name === "Source") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              Source
                            </th>
                          );
                        }
                        if (col.name === "UTM Source") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              UTM Source
                            </th>
                          );
                        }
                        if (col.name === "UTM Medium") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              UTM Medium
                            </th>
                          );
                        }
                        if (col.name === "UTM Campaign") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              UTM Campaign
                            </th>
                          );
                        }
                        if (col.name === "Referral code") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              Referral code
                            </th>
                          );
                        }
                        if (col.name === "Platform User Type") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Platform User Type</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                User Type
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Platform Usage Status") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Platform Usage Status</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Usage Status
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "App User Since") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>App User Since</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                App User Since
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Web User Since") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Web User Since</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Web User Since
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Platform Registration Date") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Platform Registration Date</Tooltip>
                              }
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Registration Date
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Last Active Date") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Last Active Date</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Last Active Date
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Total Days Active") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Total Days Active</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Total Days Active
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Subscription Tier") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Subscription Tier</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Subscription
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Time Since Subscription") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Time Since Subscription</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Time Since Subscription{" "}
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Days in Current Subscription") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Days in Current Tier</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Current Tier
                              </th>
                            </Whisper>
                          );
                        }

                        if (col.name === "Days Between Signup and Invite") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>
                                  Days Between Signup and Invite
                                </Tooltip>
                              }
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                {" "}
                                Signup and Invite
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Engagement Score") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Engagement Score</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                {" "}
                                Score
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Investment Account Numbers") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Investment Account Numbers</Tooltip>
                              }
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                {" "}
                                Account Number
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Regulation Types") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Regulation Types</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                <div className="cls_cell_Flex">
                                  <span>Regulation Types</span>
                                  <Whisper
                                    placement="top"
                                    controlId="control-id-hover"
                                    trigger="hover"
                                    speaker={
                                      <Tooltip>
                                        The data is not reliable
                                      </Tooltip>
                                    }
                                  >
                                    <span className="cls_red_dot"></span>
                                  </Whisper>
                                </div>
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Accredited") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Accredited Investor Status</Tooltip>
                              }
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                <div className="cls_cell_Flex">
                                  <span>Accredited</span>
                                  <Whisper
                                    placement="top"
                                    controlId="control-id-hover"
                                    trigger="hover"
                                    speaker={
                                      <Tooltip>
                                        The data is not reliable
                                      </Tooltip>
                                    }
                                  >
                                    <span className="cls_red_dot"></span>
                                  </Whisper>
                                </div>
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Dealmaker Certificate") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Dealmaker Certificate</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                <div className="cls_cell_Flex">
                                  <span>Certificate</span>
                                  <Whisper
                                    placement="top"
                                    controlId="control-id-hover"
                                    trigger="hover"
                                    speaker={
                                      <Tooltip>
                                        The data is not reliable
                                      </Tooltip>
                                    }
                                  >
                                    <span className="cls_red_dot"></span>
                                  </Whisper>
                                </div>
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Signed Date") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Signed Date</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                <div className="cls_cell_Flex">
                                  <span>Signed Date</span>
                                  <Whisper
                                    placement="top"
                                    controlId="control-id-hover"
                                    trigger="hover"
                                    speaker={
                                      <Tooltip>
                                        The data is not reliable
                                      </Tooltip>
                                    }
                                  >
                                    <span className="cls_red_dot"></span>
                                  </Whisper>
                                </div>
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Accepted Date") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Accepted Date</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                <div className="cls_cell_Flex">
                                  <span>Accepted Date</span>
                                  <Whisper
                                    placement="top"
                                    controlId="control-id-hover"
                                    trigger="hover"
                                    speaker={
                                      <Tooltip>
                                        The data is not reliable
                                      </Tooltip>
                                    }
                                  >
                                    <span className="cls_red_dot"></span>
                                  </Whisper>
                                </div>
                              </th>
                            </Whisper>
                          );
                        }

                        
                        if (col.name === "Number of Investments") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Number of Investments</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Investments{" "}
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Investment Currency") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Investment Currency</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Currency{" "}
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Initial Shares") {
                          return (
                            <th
                              key={col.name}
                              data-column-id={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col.name ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col.name
                                    ? "#FFF9EF"
                                    : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              <div className="cls_cell_Flex">
                                <span>Initial shares</span>
                              </div>
                            </th>
                          );
                        }
                        if (col.name === "Weighted Average Shares") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Weighted Average Shares</Tooltip>
                              }
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Average Shares
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Estimated Portfolio Value") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Estimated Portfolio Value</Tooltip>
                              }
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Portfolio Value{" "}
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Valuation Basis") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              Valuation Basis
                            </th>
                          );
                        }
                        if (col.name === "Time-Based Bonus Shares") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                                textAlign: "center",
                              }}
                            >
                              Time Based Bonus
                            </th>
                          );
                        }
                        if (col.name === "Amount-Based Bonus Shares") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Amount Based Bonus</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Amount Based Bonus
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Repeat Investor Bonus") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Repeat Investor Bonus</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Repeat Investor Bonus
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Premium Subscriber Bonus") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={
                                <Tooltip>Premium Subscription Bonus</Tooltip>
                              }
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                P. Sub. Bonus
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Event Based Bonus") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Event Based Bonus</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                  textAlign: "center",
                                }}
                              >
                                Event Based Bonus
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Total Bonus Shares") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Total Bonus Shares</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                Total Bonus
                              </th>
                            </Whisper>
                          );
                        }
                        if (col.name === "Notes") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              Notes
                            </th>
                          );
                        }
                        if (col.name === "Mailing Address") {
                          return (
                            <th
                              key={col.name}
                              draggable={col.isDraggable}
                              onDragStart={(e) => handleDragStart(e, col.name)}
                              onDrop={(e) => handleDrop(e, col.name)}
                              onDragOver={handleDragOver}
                              style={{
                                cursor: "pointer",
                                opacity: draggedColumn === col ? 0.4 : 1,
                                backgroundColor:
                                  draggedColumn === col ? "#FFF9EF" : "#FFF9EF",
                                transition:
                                  "opacity 0.2s ease, background-color 0.2s ease",
                              }}
                            >
                              Address
                            </th>
                          );
                        }
                        if (col.name === "certificate") {
                          return (
                            <Whisper
                              placement="top"
                              controlId="control-id-hover"
                              trigger="hover"
                              speaker={<Tooltip>Certificate Upload</Tooltip>}
                            >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                Certificate
                              </th>
                            </Whisper>
                          );
                        }

                        if (col.name === "Configure Bonus") {
                          return (
                            <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>Add or update existing bonus</Tooltip>} >
                              <th
                                key={col.name}
                                data-column-id={col.name}
                                draggable={col.isDraggable}
                                onDragStart={(e) =>
                                  handleDragStart(e, col.name)
                                }
                                onDrop={(e) => handleDrop(e, col.name)}
                                onDragOver={handleDragOver}
                                style={{
                                  cursor: "pointer",
                                  opacity: draggedColumn === col ? 0.4 : 1,
                                  backgroundColor:
                                    draggedColumn === col
                                      ? "#FFF9EF"
                                      : "#FFF9EF",
                                  transition:
                                    "opacity 0.2s ease, background-color 0.2s ease",
                                }}
                              >
                                Configure Bonus
                              </th>
                            </Whisper>
                          );
                        }

                        return null;
                      })}
                    </tr>
                  </thead>
                  <tbody>
                    {reportdata && reportdata.length === 0 ? (
                      <tr>
                        <td colSpan="14" style={{ textAlign: "center", fontSize: 20, paddingTop: 60, paddingBottom: 30, }} >
                          No data available
                        </td>
                      </tr>
                    ) : (
                      reportdata &&
                      reportdata.map((item, index) => (
                        <>
                          <tr style={{ cursor: "pointer" }}
                            className={
                              index % 2 === 0
                                ? "accordion-toggle collapsed table_tr_odd"
                                : " accordion-toggle collapsed table_tr_even"
                            }>
                            {columnOrder.map((col) => {
                              if (col.name === "Action")
                                return (
                                  <td style={{ textAlign: "center" }}>
                                    <button
                                      className="btn_edit_icon"
                                      onClick={() => handleEditModalOpen(item)}
                                    >
                                      <i className="icon-edit"></i>
                                    </button>
                                  </td>
                                );
                              if (col.name === "Investor ID")
                                return <td key={col.name}>INV-{item.id}</td>;

                              if (col.name === "Full Name")
                                return (
                                  // onClick={handleEditModalOpen}
                                  <td
                                    key={col.name}
                                    style={{ fontWeight: 600 }}
                                     onClick={() => handleRowClick(index)}
                                  >
                                    <div className="name__col_cell">
                                      <span>{item.name}</span>
                                       {item.more_invesment_count > 0 && (
                                                                              <Whisper
                                                                                placement="top"
                                                                                controlId="control-id-hover"
                                                                                trigger="hover"
                                                                                speaker={
                                                                                  <Tooltip>
                                                                                    Number Of Investments
                                                                                  </Tooltip>
                                                                                }
                                                                              >
                                                                                <span className="entry_number">
                                                                                  {item.more_invesment_count}
                                                                                </span>
                                                                              </Whisper>
                                                                            )}
                                    </div>
                                  </td>
                                );
                              if (col.name === "Joint Holder Name")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ fontWeight: 600 }}
                                  >
                                    <div className="name__col_cell">
                                      <span>
                                        {item.joint_holder_name || "-"}
                                      </span>
                                    </div>
                                  </td>
                                );
                              if (col.name === "Email Address")
                                return (
                                  <td key={col.name} data-column-id={col.name}>
                                    {item.email}
                                  </td>
                                );
                              if (col.name === "Phone Number")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ fontWeight: 600 }}
                                    data-column-id={col.name}
                                  >
                                    {formatPhoneNumberGlobal(item.phone)}
                                  </td>
                                ); //formatPhoneNumberGlobal(item.phone)
                              if (col.name === "Country")
                                return (
                                  <td
                                    key={col.name}
                                    style={{}}
                                    data-column-id={col.name}
                                  >
                                    <div className="company_name_td">
                                      {item.country ? (
                                        <>
                                          <div className="clogo">
                                            <CircleFlag
                                              countryCode={item.countryCode?.toLowerCase()}
                                              style={{ width: 30, height: 30 }}
                                            />
                                          </div>
                                          {item.country}
                                        </>
                                      ) : (
                                        <div className="clogo">-</div>
                                      )}
                                    </div>
                                  </td>
                                );
                              if (col.name === "Local Time")
                                return (
                                  <td key={col.name} data-column-id={col.name}>
                                    <Whisper
                                      placement="top"
                                      controlId="control-id-hover"
                                      trigger="hover"
                                      speaker={
                                        <Tooltip>{item.time_zone}</Tooltip>
                                      }
                                    >
                                      <span>
                                        <LiveTimeCell
                                          timezone={item.time_zone}
                                        />
                                      </span>
                                    </Whisper>
                                  </td>
                                );
                              if (col.name === "Likehood Score")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                {item.likelihood_score ? ( 
                                   <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={ <Tooltip>{item.priority}</Tooltip> } >
                                    <div className='table_title_icon'> <span className={priorityClassMap[item.priority] || ''}>{item.likelihood_score}</span> </div>
                                  </Whisper>
                                 ) : <span>-</span> }
                                  </td>
                                );
                              if (col.name === "Investment Invite Date")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.invite_date}
                                  </td>
                                );
                              if (col.name === "Time to First Contact")
                                return (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                    data-column-id={col.name}
                                  >
                                    <h6
                                      style={{
                                        fontSize: 13,
                                        color: "#666",
                                        textAlign: "left",
                                      }}
                                    >
                                      {" "}
                                      <span
                                        className={`time_fcontact_circle ${
                                          item.color_code === "green"
                                            ? "time_fcontact_circle_green"
                                            : item.color_code === "yellow"
                                            ? "time_fcontact_circle_yellow"
                                            : item.color_code === "orange"
                                            ? "time_fcontact_circle_orange"
                                            : item.color_code === "red"
                                            ? "time_fcontact_circle_red"
                                            : ""
                                        }`}
                                      ></span>
                                      <span>
                                        {item.time_to_first_comment || "-"}
                                      </span>
                                    </h6>
                                  </td>
                                );
                              if (col.name === "Total Invested Amount")
                                return (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                    data-column-id={col.name}
                                  >
                                    {item.investment_amount || "-"}
                                  </td>
                                );
                              if (col.name === "Assigned User")
                                return (
                                  <td style={{}} data-column-id={col.name}>
                                    {item.reassign_msg?.length > 0 ? (
                                      <Whisper
                                        placement="top"
                                        controlId="control-id-hover"
                                        trigger="hover"
                                        speaker={
                                          <Tooltip>{item.reassign_msg}</Tooltip>
                                        }
                                      >
                                        <div
                                          style={{ cursor: "pointer" }}
                                          className="name__col_cell"
                                        >
                                          {" "}
                                          <div className="img_name_profile">
                                            {" "}
                                            <img
                                              src={item.user_profile_img}
                                              alt="User"
                                            />{" "}
                                          </div>{" "}
                                          <span>{item.user_in_charge}</span>{" "}
                                        </div>
                                      </Whisper>
                                    ) : (
                                      <div className="name__col_cell">
                                        {" "}
                                        <div className="img_name_profile">
                                          {" "}
                                          <img
                                            src={item.user_profile_img}
                                          />{" "}
                                        </div>{" "}
                                        <span> {item.user_in_charge} </span>{" "}
                                      </div>
                                    )}
                                  </td>
                                );
                              if (col.name === "IR Notes")
                                return (
                                  <td style={{}} data-column-id={col.name}>
                                    <Button
                                      className="btn__comment__notes"
                                      data-comment={`${item.id}`}
                                      onClick={() => handleCommentBoxOpen(item)}
                                    >
                                      <img src={iconNotes} />
                                    </Button>
                                  </td>
                                );

                              if (col.name === "Source")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.source || "-"}
                                  </td>
                                );
                              if (col.name === "UTM Source")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.utm_source || "-"}
                                  </td>
                                );
                              if (col.name === "UTM Medium")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.utm_medium || "-"}
                                  </td>
                                );
                              if (col.name === "UTM Campaign")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.utm_campaign || "-"}
                                  </td>
                                );
                              if (col.name === "Referral code")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {"-"}
                                  </td>
                                );

                              if (col.name === "Platform User Type")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {"-"}
                                  </td>
                                );
                              if (col.name === "Platform Usage Status")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.platform_use_status || "-"}
                                  </td>
                                );
                              if (col.name === "App User Since")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {"-"}
                                  </td>
                                );
                              if (col.name === "Web User Since")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.created_at || "-"}
                                  </td>
                                );
                              if (col.name === "Platform Registration Date")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.created_at || "-"}
                                  </td>
                                );
                              if (col.name === "Last Active Date")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.last_login_at || "-"}
                                  </td>
                                );
                              if (col.name === "Total Days Active")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {"-"}
                                  </td>
                                );
                              if (col.name === "Subscription Tier")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    <span
                                      className={` ${
                                        {
                                          PREMIUM: "tier__tag tier_premium",
                                          FREEMIUM: "tier__tag tier_freemium",
                                          STARTER: "tier__tag tier_starter",
                                          PREMIUM_PLUS:
                                            "tier__tag tier_premium_plus",
                                          "Not a user":
                                            "tier__tag tier_not_user",
                                        }[item.subscription] || ""
                                      }`}
                                    >
                                      {item.subscription || "-"}
                                    </span>
                                  </td>
                                );

                              if (col.name === "Days in Current Subscription")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {"-"}
                                  </td>
                                );

                              if (col.name === "Days Between Signup and Invite")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.subscription_expiry_date || "-"}
                                  </td>
                                );
                              if (col.name === "Engagement Score")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {"-"}
                                  </td>
                                );

                              if (col.name === "Investment Account Numbers")
                                return (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                    data-column-id={col.name}
                                  >
                                    {"-"}
                                  </td>
                                );
                              if (col.name === "Regulation Types")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    <span>{"-"}</span>
                                  </td>
                                );
                              if (col.name === "Accredited")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    <span>{item.accredited || "-"}</span>
                                  </td>
                                );
                              if (col.name === "Dealmaker Certificate")
                                return (
                                  <td style={{ textAlign: "center" }} data-column-id={col.name} >
                                    {item.share_certificate_url && (
                                    <span><img src={IconCertificate} height={30} onClick={() => handlePreviewClick(item.share_certificate_url)} /></span>
                                    )}
                                  </td>
                                  
                                );
                              if (col.name === "Signed Date")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    <span>{"-"}</span>
                                  </td>
                                );
                              if (col.name === "Accepted Date")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    <span>{"-"}</span>
                                  </td>
                                );
                              if (col.name === "Time Since Subscription")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                     {item.subscriptionDuration ? ( 
                                          <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={ <Tooltip>{item.subscription_date}</Tooltip> } >
                                            <span>{item.subscriptionDuration}</span>
                                          </Whisper>
                                      ) : <span>-</span> }
                                  </td>
                                );

                              if (col.name === "Number of Investments")
                                return (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                    data-column-id={col.name}
                                  >
                                    {"-"}
                                  </td>
                                );
                              if (col.name === "Investment Currency")
                                return (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                    data-column-id={col.name}
                                  >
                                    {item.investor_currency || "-"}
                                  </td>
                                );
                              if (col.name === "Initial Shares")
                                return (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                    data-column-id={col.name}
                                  >
                                    {item.share || "-"}
                                  </td>
                                );
                              if (col.name === "Weighted Average Shares")
                                return (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                    data-column-id={col.name}
                                  >
                                    {"-"}
                                  </td>
                                );
                              if (col.name === "Estimated Portfolio Value")
                                return (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                    data-column-id={col.name}
                                  >
                                    {"-"}
                                  </td>
                                );
                              if (col.name === "Valuation Basis")
                                return (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                    data-column-id={col.name}
                                  >
                                    {"-"}
                                  </td>
                                );

                              if (col.name === "Time-Based Bonus Shares")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.time_based_bonus || "-"}
                                  </td>
                                );
                              if (col.name === "Amount-Based Bonus Shares")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.amount_based_bonus || "-"}
                                  </td>
                                );
                              if (col.name === "Repeat Investor Bonus")
                                return (
                                  <td
                                    style={{ textAlign: "center" }}
                                    data-column-id={col.name}
                                  >
                                    {item.existing_investor_bonus || "-"}
                                  </td>
                                );
                              if (col.name === "Premium Subscriber Bonus")
                                return (
                                  <td
                                    style={{
                                      fontWeight: 600,
                                      textAlign: "center",
                                    }}
                                    data-column-id={col.name}
                                  >
                                    {item.premium_subscription_bonus || "-"}
                                  </td>
                                );
                              if (col.name === "Event Based Bonus")
                                return (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                    data-column-id={col.name}
                                  >
                                    {item.event_based_bonus || "-"}
                                  </td>
                                );
                              if (col.name === "Total Bonus Shares")
                                return (
                                  <td
                                    style={{
                                      textAlign: "center",
                                      fontWeight: 600,
                                    }}
                                    data-column-id={col.name}
                                  >
                                    {item.total_bonus || "-"}
                                  </td>
                                );

                              if (col.name === "Notes")
                                return (
                                  <td style={{}} data-column-id={col.name}>
                                    <Whisper
                                      placement="top"
                                      controlId="control-id-hover"
                                      trigger="hover"
                                      speaker={<Tooltip>{item.notes}</Tooltip>}
                                    >
                                      <span style={{ cursor: "pointer" }}>
                                        {notes__truncate(item.notes)}
                                      </span>
                                    </Whisper>
                                  </td>
                                );
                              if (col.name === "Mailing Address")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ fontWeight: 600 }}
                                    data-column-id={col.name}
                                  >
                                    <Whisper
                                      placement="top"
                                      controlId="control-id-hover"
                                      trigger="hover"
                                      speaker={
                                        <Tooltip>{item.address}</Tooltip>
                                      }
                                    >
                                      <span style={{ cursor: "pointer" }}>
                                        {address__truncate(item.address)}
                                      </span>
                                    </Whisper>
                                  </td>
                                );

                              if (col.name === "certificate")
                                return (
                                  <td
                                    key={col.name}
                                    style={{ fontWeight: 600 }}
                                    data-column-id={col.name}
                                  >
                                    {/* <Button style={{ cursor: 'pointer' }} onClick={() => handleUploadClick(item)}> Upload </Button> */}
                                    {item.more_invesment_count == 0 && (
                                    <Button
                                      className="btn__upload"
                                      onClick={() => handleUploadClick(item)}
                                    >
                                      <img src={iconUploadbtn} />{" "}
                                      <span>Upload</span>
                                    </Button>
                                    )} 
                                  </td>
                                );

                                 if (col.name === "Configure Bonus")
                                return (
                                  <td style={{ textAlign: "center" }} data-column-id={col.name} >
                                    <span><img src={iconBonus} height={30} onClick={() => handleAddBonus(item)} /></span>
                                  </td>
                                  
                                );

                              return null;
                            })}
                          </tr>
                          <tr className="hiddenRow">
                                                      <td
                                                        colspan="32"
                                                        style={{
                                                          padding: 0,
                                                          position: "sticky",
                                                          left: 0,
                                                        }}
                                                      >
                                                        <div
                                                          className={`accordian-body collapse ${
                                                            expandedRowId === index ? "show" : "hide"
                                                          }`}
                                                          id={`TableRow${index}`}
                                                        >
                                                          {item.more_invesment?.length > 1 ? (
                                                            <div className="table_accordion_row">
                                                              <div
                                                                className="table_accordion_col"
                                                                style={{ width: "100%" }}
                                                              >
                                                                <div className="etf_fieldset_row etf_fieldset_row_new">
                                                                  <fieldset className="fieldset_col three_rows_fieldset">
                                                                    <legend className="legend_title">
                                                                      Investment Details
                                                                    </legend>
                          
                                                                    {item.more_invesment?.map(
                                                                      (subitem, i) => (
                                                                        <div
                                                                          className={`purification_fieldset_row ${
                                                                            subitem.lasted_invesment
                                                                              ? "clsActiveInvestor"
                                                                              : ""
                                                                          }`}
                                                                        >
                                                                          <div className="input__group_redis">
                                                                            <div className="input__group_redis_label">
                                                                              Investor ID
                                                                            </div>
                                                                            <div className="input__group_redis_value">
                                                                              {subitem.id}
                                                                            </div>
                                                                          </div>
                          
                                                                          <div className="input__group_redis">
                                                                            <div className="input__group_redis_label">
                                                                              Investment Amount
                                                                            </div>
                                                                            <div className="input__group_redis_value">
                                                                              {subitem.investment_amount}
                                                                            </div>
                                                                          </div> 
                          
                                                                          <div className="input__group_redis">
                                                                            <div className="input__group_redis_label">
                                                                              status
                                                                            </div>
                                                                            <div className="input__group_redis_value">
                                                                              {subitem.status}
                                                                            </div>
                                                                          </div>
                                                                          <div className="input__group_redis">
                                                                            <div className="input__group_redis_label">
                                                                              Payment
                                                                            </div>
                                                                            <div className="input__group_redis_value">
                                                                              {subitem.payment}
                                                                            </div>
                                                                          </div>
                          
                                                                          <div className="input__group_redis">
                                                                            <div className="input__group_redis_label">
                                                                              Created At
                                                                            </div>
                                                                            <div
                                                                              className={`input__group_redis_value`}
                                                                            >
                                                                              {subitem.created_at}
                                                                            </div>
                                                                          </div>
                          
                                                                          <div className="input__group_redis_label">
                                                                            <Button
                                                                              className="btn__upload"
                                                                              onClick={() =>
                                                                                handleUploadClick(subitem)
                                                                              }
                                                                            >
                                                                              <img src={iconUploadbtn} />{" "}
                                                                              <span>Upload</span>
                                                                            </Button>
                                                                          </div>
                          
                                                                          <div className="">
                                                                            <Whisper
                                                                              placement="left"
                                                                              trigger="click"
                                                                              speaker={renderSpeaker}
                                                                              open3={open}
                                                                              onOpenChange={(nextOpen) =>
                                                                                setOpen3(nextOpen)
                                                                              }
                                                                            >
                                                                              <Button className="clsInvestorDelete">
                                                                                <i className="icon-delete" />
                                                                              </Button>
                                                                            </Whisper>
                                                                          </div>
                                                                        </div>
                                                                      )
                                                                    )}
                                                                  </fieldset>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          ) : (
                                                            <>
                                                              <div className="table_accordion_row">
                                                                <div
                                                                  className="table_accordion_col"
                                                                  style={{ width: "100%" }}
                                                                >
                                                                  <div className="etf_details_row pb-2">
                                                                    <h4>No History Found</h4>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </>
                                                          )}
                                                        </div>
                                                      </td>
                                                    </tr>
                        </>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              {reportCount > 1 && renderPagination()}
            </>
          )}
        </div>
      </div>

      <Modal open={EditModalOpen} onClose={handleEditModalClose} className="edit_status_modal dual_modal_wrap">
        <Modal.Body>
          <div className='dual_modal_row'>
            {/* If count = 0 then add this to left col : style={{maxWidth:740, marginLeft:'auto', marginRight:'auto'}} */}
            <div className='dual_modal_col dual_modal_left_col'  style={reassignCount === 0 ? { maxWidth: 740, marginLeft: 'auto', marginRight: 'auto' } : {}} >
              <Modal.Header className="edit_modal_header">
                <Modal.Title className="edit_modal_title">Re-Assign User</Modal.Title>
              </Modal.Header>
              <div className="edit_modal_content">
                <div className="edit_status_field">
                  <label>Select IR User</label>
                  <div className="select_edit_status">
                    <SelectPicker
                      data={userData}
                      searchable={true}
                      style={{ width: '100%' }}
                      placeholder="Select IR User"
                      onChange={handleUserChange}
                      value={assignUserid}
                      renderMenuItem={(label, item) => (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <Avatar
                            circle
                            src={item.profile_img}
                            style={{ width: 30, height: 30 }}
                          />
                          <span>{label}</span>
                        </div>
                      )}
                    />
                  </div>
                </div>

                <div className="edit_status_field mt-4">
                  <label>Comment
                    <Whisper placement="top" controlId="control-id-hover" trigger="hover" speaker={<Tooltip>You may optionally add a reason for assigning this task to help provide clarity to the assigned user.</Tooltip>}>
                      <img src={Icon_info} />
                    </Whisper>
                  </label>
                  <textarea row="3" className="form-control"
                    value={assignUserComment}
                    onChange={(e) => setAssignUserComment(e.target.value)}></textarea>
                </div>

              </div>
              <div className="modal_footer_edit_status">
                <div className="btn__group">
                  <button type="button" className="btn_cancel" onClick={handleEditModalClose}>Cancel</button>
                  <Button className="btn__save" onClick={handleReassignSave} loading={isLoading}>Re-assign</Button>
                </div>
              </div>
            </div>

    {/* If count = 0 then add this to left col : style={{display:'none'}} */}
            <div className='dual_modal_col dual_modal_right_col' style={reassignCount === 0 ? { display: 'none' } : {}} >
              <Modal.Header className="edit_modal_header">
                <Modal.Title className="edit_modal_title">Assign History</Modal.Title>
              </Modal.Header>
              <div className='company_table_list table-responsive'>
                <table className='table'>
                  <thead>
                    <tr>
                      <th>Previous User</th>
                      <th>Current User</th>
                      <th>Assigned By</th>
                      <th>Assigned On</th>
                    </tr>
                  </thead>
                  <tbody>

                   {reassignHistory.map((item, index) => (
                <tr key={index}>
                  <td>{item.old_user_name}</td>
                  <td>{item.new_user_name}</td>
                  <td>{item.updated_by_name}</td>
                  <td style={{ color: '#777' }}>
                    {item.updated_at}
                  </td>
                </tr>
              ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Modal.Body>

      </Modal>


        <Modal open={editModalBonusOpen} onClose={handleEditBonusModalClose} className='modal fade new_investor_lead_modal' aria-hidden="true"  backdrop="static" keyboard={false}>
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">
                                Bonus {`INV` + -selectedFileInvestorId}
                            </h4>
                            <button type="button" className="btn-close" onClick={handleEditBonusModalClose} aria-label="Close"></button>

                        </div>

                        <div class="modal-body bonus_modal_body">
                            <div className='row'>
                                <div className='col-sm-6 col-lg-4 mt-4'>
                                    <label>Amount-Based</label>
                                    {/* onChange={(e) => setAmountBonus(e.target.value)} */}
                                    <input type='text' className='form-control log_activity_select' placeholder='Enter Amount' value={AmountBonus} onChange={(e) => handleNumberInputChange(e.target.value, setAmountBonus)} />
                                </div>
                                <div className='col-sm-6 col-lg-4 mt-4'>
                                    <label>Time-Based</label>
                                    <input type='text' className='form-control log_activity_select' placeholder='Enter Time-Based'  value={TimeBonus} onChange={(e) => handleNumberInputChange(e.target.value, setTimeBonus)} />
                                </div>
                                <div className='col-sm-6 col-lg-4 mt-4'>
                                    <label>Event-Based</label>
                                    <input type='text' className='form-control log_activity_select' placeholder='Enter Event-Based' value={EventBonus} onChange={(e) => handleNumberInputChange(e.target.value, setEventBonus)} />
                                </div>
                                <div className='col-sm-6 mt-4'>
                                    <label>Existing Investor</label>
                                    <input type='text' className='form-control log_activity_select' placeholder='Enter Existing Investor' value={ExistingBonus} onChange={(e) => handleNumberInputChange(e.target.value, setExistingBonus)}/>
                                </div>
                                <div className='col-sm-6 mt-4'>
                                    <label>Existing Premium User</label>
                                    <input type='text' className='form-control log_activity_select' placeholder='Enter Existing Premium User' value={PremiumBonus}  onChange={(e) => handleNumberInputChange(e.target.value, setPremiumBonus)} />
                                </div>
                            </div>
                            <div className="btn__group mt-5">
                                <button type="button" className="btn_cancel" onClick={handleEditBonusModalClose}>Cancel</button>
                                <button className="btn__save" onClick={handleSaveBonus}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>



      {/* <Modal open={EditModalOpen} onClose={handleEditModalClose}
        className="edit_status_modal modal_vflex_end slide-from-right"
        placement="right"
        transition
      >
        <Modal.Header className="edit_modal_header">
          <Modal.Title className="edit_modal_title">Update Waiting List</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="edit_modal_content">
            <div className="edit_status_field">
              <div class="duplicate_form_row">
                <div class="duplicate_form_col">
                  <label>Phone Number</label>
                  <input type='text' placeholder='Enter Number' className='form-control' />
                </div>
                <div class="duplicate_form_col">
                  <label>Country</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Country Residence"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Preferred Language</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Language"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>Opt-In Consent</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Opt-In Consent"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Inv. Int. Amount</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Int. Amount"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>Est. Inv. Timeline</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Timeline"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Accredited Investor Status</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Acc. Inv. Status"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>Investor Type</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Investor Type"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Investment Likelihood Score</label>
                  <input type='text' placeholder='Inv. Likelihood Score' className='form-control' />
                </div>
                <div class="duplicate_form_col">
                  <label>Status</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Status"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Priority Level</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Level"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>IR Tags</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select IR Tags"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col">
                  <label>Priority Level</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select Level"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
                <div class="duplicate_form_col">
                  <label>IR Tags</label>
                  <div className='select_drop_picker'>
                    <SelectPicker
                      data={StatusData}
                      searchable={false}
                      tyle={{ width: '100%' }}
                      placeholder="Select IR Tags"
                      onChange={handleETFStatusChange}
                      value={selectedStatus}
                    />
                  </div>
                </div>
              </div>

              <div class="duplicate_form_row mt-4">
                <div class="duplicate_form_col" style={{ width: '100%' }}>
                  <label>IR Notes</label>
                  <textarea className='form-control' placeholder='Notes' rows={3} style={{ height: 'auto' }}></textarea>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal_footer_edit_status">
          <div className="btn__group">
            <button type="button" className="btn_cancel" onClick={handleEditModalClose}>Cancel</button>
            <button className="btn__save" onClick={handleManualSave}>Update</button>
          </div>
        </Modal.Footer>
      </Modal> */}

      <Drawer
              open={open2}
              onClose={handleCloseDrawer}
              size="xs"
              placement="left"
              className="show_hide_drawer"
            >
              <Drawer.Header>
                <Drawer.Title>Show & Hide Columns</Drawer.Title>
              </Drawer.Header>
              <Drawer.Body>
                <div style={{ marginTop: 30 }}>
                  <div
                    style={{ display: "flex", flexDirection: "column", gap: "10px" }}
                  >
                    {Object.entries(checkboxColumnMap).map(([id, columnName]) => (
                      <div className="form-check" key={id}>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={id}
                          checked={columnOrder.some((col) => col.name === columnName)} // ✅ fix here
                          onChange={(e) =>
                            handleCheckboxChange(columnName, e.target.checked)
                          }
                        />
                        <label className="form-check-label" htmlFor={id}>
                          {columnName}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </Drawer.Body>
              <Drawer.Footer>
                <Button
                  className="btn__cancel"
                  style={{ width: "100%", background: "#FFF" }}
                  onClick={handleReset}
                >
                  Reset
                </Button>
              </Drawer.Footer>
            </Drawer>

      <Modal
        open={commentBoxOpen}
        onClose={handleCommentBoxClose}
        className="comment_modal_body"
        style={{ right: 0 }}
      >
        {commentLoading ? (
          <div style={{ backgroundColor: "white", height: "100vh" }}>
            <Placeholder.Paragraph rows={8} />
            <Loader center content={commentLoading} />
          </div>
        ) : (
          <>
            <Modal.Header className="comment_modal_header">
              <Modal.Title className="comment_modal_title">
                {commentFetchTextValue}
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div className="comment_modal_content">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <h4 className="mb-3">
                    Comments({commentCount}
                    {})
                  </h4>
                  <div className="">
                    <h6
                      style={{
                        fontSize: 13,
                        color: "#666",
                        textAlign: "right",
                      }}
                    >
                      Invite Time:{" "}
                      <span style={{ fontSize: 13, color: "#000" }}>
                        {dateInvited || "-"}
                      </span>
                    </h6>
                    <h6
                      style={{
                        fontSize: 13,
                        color: "#666",
                        textAlign: "right",
                      }}
                    >
                      Time to First Contact:{" "}
                      <span
                        style={{
                          fontSize: 13,
                          color: "#000",
                          fontWeight: 500,
                          marginLeft: 6,
                        }}
                      >
                        <span
                          className={`time_fcontact_circle ${
                            colorCode === "green"
                              ? "time_fcontact_circle_green"
                              : colorCode === "yellow"
                              ? "time_fcontact_circle_yellow"
                              : colorCode === "orange"
                              ? "time_fcontact_circle_orange"
                              : colorCode === "red"
                              ? "time_fcontact_circle_red"
                              : ""
                          }`}
                        ></span>
                        <span>{firstTimeToContact || "-"}</span>
                      </span>
                    </h6>
                  </div>
                </div>
                {commentdata && commentdata.length === 0 ? (
                  <div className="zero_comment">
                    <img src={IconNoComment} />
                    <p>No Comments yet</p>
                  </div>
                ) : (
                  commentdata &&
                  commentdata.map((item, index) => (
                    <div className="comment_modal_box">
                      <div className="flex_sp_row comment_modal_box_top">
                        <h5>By {item.full_name}</h5>
                        <div className="comment_date">{item.created_at}</div>
                      </div>

                      <div className="flex_sp_row comment_modal_box_bottom clsOneline">
                        <p
                          dangerouslySetInnerHTML={{ __html: item.comment }}
                        ></p>
                        <a
                          href="javascript:void(0);"
                          className="cdelete_icon"
                          onClick={() => deleteComment(item)}
                        >
                          <i className="icon-delete"></i>
                        </a>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </Modal.Body>
            <Modal.Footer className="modal_footer_comment_form">
              <div className="modal_footer_comment_inner">
                <div className="mt-3">
                  <label className="label_form">Comment</label>
                  {/* <input type='text' className='form-control' placeholder='Enter your comment' id="txtComment" /> */}
                  <textarea
                    className="form__control textarea_resisable"
                    placeholder="Enter your comment"
                    id="txtComment"
                  ></textarea>
                </div>

                <div className="btn__group">
                  <button
                    type="button"
                    className="btn_cancel"
                    onClick={handleCommentBoxClose}
                  >
                    Close
                  </button>
                  <Button
                    className="btn_comment"
                    onClick={() => addComment()}
                    loading={addCommentLoader}
                  >
                    Add Comment
                  </Button>
                </div>
              </div>
            </Modal.Footer>
          </>
        )}
      </Modal>

      <div
        className={`modal fade upload_file_modals ${
          showUploadManualModal ? "d-block show" : "d-none"
        }`}
        id="UploadFileModal"
        tabIndex="-1"
        aria-labelledby="UploadFileModalLabel"
        aria-hidden="true"
        data-bs-keyboard="false"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ maxWidth: 760 }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title fs-5">
                Upload Files For {`INV` + -selectedFileInvestorId}
              </h4>
              <p>
                Add your documents here, and you can upload up to 30 MB files
                max
              </p>
            </div>
            <div className="modal-body">
              <div className="upload_section_main">
                <Uploader
                  action=""
                  draggable
                  //  multiple // Allow multiple files
                  listType="text"
                  accept=".jpg,.png,.pdf"
                  // onChange={(files) => files.forEach((file) => handleFileSelect(file))}
                  onChange={(files) => {
                    if (uploadedfileList.length > 0) {
                      toast({
                        description:
                          "Only one file is allowed. Please delete the existing file before uploading a new one.",
                        status: "error",
                        duration: 5000,
                        isClosable: true,
                        position: "bottom",
                      });
                      return;
                    }

                    if (files.length > 1) {
                      toast({
                        description: "Please upload only one file at a time.",
                        status: "error",
                        duration: 5000,
                        isClosable: true,
                        position: "bottom",
                      });
                      return;
                    }

                    const file = files[0];
                    handleFileSelect(file);
                  }}
                  //defaultFileList={fileList1}
                  fileList={uploadedfileList}
                  fileListVisible={false} // file list visible nahi hogi.
                  //onRemove={handleRemove}
                >
                  <div>
                    <div className="upload_section">
                      <img src={iconUpload} alt="Upload Icon" />
                      <p>Drag your file(s) to start uploading</p>
                      <div className="or__text">
                        <span>OR</span>
                      </div>
                      <span className="btn__browse__file">Browse files</span>
                    </div>
                    <h6 style={{ marginBottom: 10 }}>
                      Only support .jpg, .png, .pdf and files
                    </h6>
                  </div>
                </Uploader>

                <div className="customUploadwrap">
                  {uploadedfileList.map((file) => {
                    const percent = progress[file.name] || 101;
                    const elapsedTime = (Date.now() - file.startTime) / 1000; // in seconds
                    const estimatedTimeRemaining =
                      percent > 0
                        ? Math.max(((100 - percent) * elapsedTime) / percent, 1)
                        : 0;

                    return (
                      <div key={file.id} className="customUploadList">
                        {percent < 100 ? (
                          // **Uploading Section**
                          <div>
                            <div className="progress_row">
                              <div className="progress_text">
                                <h4>Uploading...</h4>
                                <p>
                                  {percent}%{" "}
                                  <span>
                                    {" "}
                                    • {Math.round(estimatedTimeRemaining)}{" "}
                                    seconds remaining
                                  </span>
                                </p>
                              </div>
                            </div>
                            <Progress.Line
                              percent={percent}
                              showInfo={false}
                              strokeColor="#2B3779"
                            />
                          </div>
                        ) : (
                          // **Uploaded Section**
                          <div className="customUploadProgress_row">
                            <div className="filename_row">
                              <div
                                className="class_icon"
                                style={{ cursor: "pointer" }}
                              >
                                {/* <Link  to={file.type === "pdf" ? `https://docs.google.com/viewer?url=${encodeURIComponent(file.url)}` : file.url} target="_blank" rel="noopener noreferrer"> */}
                                <img
                                  src={
                                    file.type == "pdf"
                                      ? iconPDF
                                      : file.type == "png"
                                      ? iconPNG
                                      : iconJPG
                                  }
                                  onClick={() => handlePreviewClick(file)}
                                />
                                {/* </Link> */}
                              </div>
                              <div className="class_filename">
                                <h5>{file.name}</h5>
                                <span className="file_size">
                                  {file.size} -{file.id}
                                </span>
                              </div>
                            </div>
                            <button
                              className="cls_btn_cross"
                              onClick={() => handleRemove(file)}
                            >
                              <img src={iconCancel} />
                            </button>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>

              <div className="btn__group mt-5">
                <button
                  type="button"
                  className="btn_cancel"
                  onClick={closeUploadManualModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        class={`modal fade upload_file_modal ${
          showUploadpreviewModal ? "d-block show" : "d-none"
        }`}
        id="ModalManualReport"
        tabindex="-1"
        aria-labelledby="AddNewAnalystModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <button
              type="button"
              class="btn-close"
              aria-label="Close"
              onClick={closeUploadpreviewModal}
            ></button>
            <div class="modal-body">
              {reportType === "pdf" ? (
                <iframe
                  title="LR Report PDF"
                  width="100%"
                  height="550"
                  src={preview}
                  className="iframe_pdf"
                ></iframe>
              ) : (
                <div className="upload_img_modal">
                  <img src={preview} alt="Preview" />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Investors;
